/*------------------------------------------------------------------------------------------------------------*/
/* Filename: payment.page.ts                                                                                  */
/* Description: This file is for store payment functionalities                                                 */
/* Created: 10/Nov/2021                                                                                        */
/* Copyright (c) 2023 Lottosocial by Hatchster                                                                */
/*------------------------------------------------ -----------------------------------------------------------*/

import { AsyncPipe, NgClass, NgStyle } from "@angular/common";
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  NgZone,
  OnDestroy,
  OnInit,
  Renderer2,
  ViewChild,
  inject,
  signal
} from "@angular/core";
import { AngularFireAuth } from "@angular/fire/compat/auth";
import { AngularFireFunctions } from "@angular/fire/compat/functions";
import { Firestore, collection, doc, getDoc, onSnapshot } from "@angular/fire/firestore";
import { FormBuilder, FormsModule, Validators } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { MatIcon } from "@angular/material/icon";
import { MatProgressSpinner } from "@angular/material/progress-spinner";
import { DomSanitizer } from "@angular/platform-browser";
import { ActivatedRoute, Data, Router } from "@angular/router";
import { PluginListenerHandle } from "@capacitor/core";
import { Network } from "@capacitor/network";
import { AuthPartialRegService } from "@core/AuthServices/authPartialReg/auth-partial-reg.service";
import { AuthService } from "@core/auth.service";
import { AuthStateService } from "@core/auth-state.service";
import {
  formatDisplayCurrencyAmount,
  getDefaultCurrencySymbol,
  normalizeGetRegOptMsgHtml,
  resolveLocaleAlignedPaymentHtml,
} from "@core/currency-display.util";
import { IndexedDBRecoveryService } from "@core/indexeddb-recovery.service";
import { LoadingService } from "@core/loading.service";
import { UtilityService } from "@core/utility.service";
import { IonContent, IonicModule } from "@ionic/angular";
import { TranslatePipe, TranslateService } from "@ngx-translate/core";
import { getAuth } from "firebase/auth";
import { BehaviorSubject, EMPTY, Subject, Subscription, combineLatest, forkJoin, from, interval, of, race, timer } from "rxjs";
import {
  catchError,
  concatMap,
  defaultIfEmpty,
  delay,
  filter,
  finalize,
  map,
  switchMap,
  take,
  takeUntil,
  tap,
  timeout,
} from "rxjs/operators";
import { bounceIn } from "src/app/animations/custom.animation";
import { CommonVariable } from "src/app/app.constants";
import { CashPurchaseService } from "src/app/services/cash-purchase.service";
import { CommonService } from "src/app/services/common/common.service";
import { GTMSagmentService } from "src/app/services/gtm-sagment.service";
import { GTMSegmentService } from "src/app/services/gtm-segment.service";
import { MixpanelService } from "src/app/services/mixpanel.service";
import { PaymentCardService } from "src/app/services/payment-card.service";
import { PaymentDataService } from "src/app/services/payment-data.service";
import { PaymentLogService } from "src/app/services/payment-log.service";
import { PaymentService } from "src/app/services/payment.service";
import { SafeLocalStorageService } from "src/app/services/safe-local-storage.service";
import { SalesJourneyIdentityService } from "src/app/services/sales-journey-identity.service";
import { SalesJourneyStateService } from "src/app/services/sales-journey-state.service";
import { FourCJourneyStateResult } from "src/app/interfaces/sales-journey-state.i";
import { SyndicateDataService } from "src/app/services/syndicate-data.service";
import { environment } from "src/environments/environment";
import Swiper from "swiper";
import type { SwiperOptions } from "swiper/types";
import { SwiperComponent, SwiperModule } from "swiper/angular";
import { InProgressAnimationComponent } from "../../../components/in-progress-animation/in-progress-animation.component";
import { SafeHtmlPipe } from "../../../pipe/safehtmlpipe";
import { WalletService } from "../../account/account-wallet/wallet.services";
import { NoThanksPopupComponent } from "../../sales/no-thanks-popup/no-thanks-popup.component";
import { StoreRepositoryService } from "../../store/store-repository.service";
import { BasePaymentService } from "./services/base-payment-service";
import { CardUpsellService, Addon } from "./services/card-upsell-service";
import { CheckoutComService } from "./services/checkout-com-service";
import { JackpotDisplayHelper } from "./services/jackpot-display-helper";
import { PaymentFlowService } from "./services/payment-flow-service";
import { PaymentNavigationService } from "./services/payment-navigation-service";
import { PaymilPaymentService } from "./services/paymil-payment-service";
import { ToastFacadeService, ToastPayload, ToastSeverity } from "@core/toast-facade.service";
import { ResourceLoaderService } from "src/app/services/resource-loader.service";
import { CheckoutFlowService, CheckoutComFlowHost, CheckoutFlowRedirectReturn } from "src/app/services/checkout-flow.service";
import { scheduleSuccessBannerHideTimer } from "../utils/success-banner.util";
declare var window;

@Component({
  animations: [bounceIn],
  selector: "app-payment",
  templateUrl: "./payment.page.html",
  styleUrls: ["./payment.page.scss", "../onesignal.scss"],
  standalone: true,
  imports: [
    IonicModule,
    FormsModule,
    SwiperModule,
    NgClass,
    InProgressAnimationComponent,
    NgStyle,
    MatIcon,
    MatProgressSpinner,
    AsyncPipe,
    SafeHtmlPipe,
    TranslatePipe,
  ],
  providers: [
    BasePaymentService,
    CardUpsellService,
    PaymentFlowService,
    PaymentNavigationService,
    PaymilPaymentService,
    JackpotDisplayHelper
  ]
})
export class PaymentPage extends PaymentLogService implements OnInit, OnDestroy, AfterViewInit {
  public safeLocalStorage = inject(SafeLocalStorageService);
  storedCards = [];
  sub: any;
  fixFooter = false;
  timer$: any;
  paymentPageData: any;
  paymentDetails: any[] = [];
  showAll: boolean;
  purchaseDetail: any = {};
  navParams: any;
  modalCtrl: any;
  firstFormGroup: any;
  isPaymentDone = false;
  proceed: boolean = true;
  responseObject: any;
  progressBar: number;
  spinnerAnimation: boolean;
  selectedCard: any = "21";
  addNewCardInProgress: boolean = false;
  addingCard: boolean;
  count: any = 0;
  paymentReceived: any;
  payment_status: any;
  pathString: any;
  jackpots;
  selectedLanguage: string = "en";
  insertCustomerPurchaseRes: any;
  paymentProsubId: any;
  loaded: boolean;
  prosub_id: any;
  qParams: any;
  offer_id: any;
  org_prosub: any;
  isOnline: boolean = true;
  processcustomer_offer: any;
  fourCPaymentResponse: any;
  userProduct$: any;
  altprosubDetails: any;
  isCappingCheckDone: boolean;
  /** True when check4cFlow reports offer capping_status / cappingStatus. */
  private isOfferCapped = false;
  showAddNewCard: boolean = false;
  translatedToastMsg: any;
  saveCardLength: any;
  syndicateId: any;
  private postPaymentTicketFlowStarted = false;
  timerOn = true;
  timeOut: boolean;
  // slide btn start
  @ViewChild("slide_btn", { static: false }) slide_btn!: ElementRef;
  swipeToBuyBtn = "checkout_try_again.swipe_to_buy";
  isActivated = false;
  maxOffset = 220; // Max swipe distance
  btnClass = "";
  isDragging = false;
  startX = 0;
  currentSliderX = 5;
  slideLocked = false;
  isDirectPayNowInProgress = false;
  paymentMode = "";
  checkoutEvent = null;
  // slide btn end
  prizeDrowAddonChecked = signal(false);
  @ViewChild("timer", { static: false }) timerspan: Data;
  origin = window.location.origin;
  public TP1: string = window.localStorage.getItem("TP1");
  public Tp2: string = window.localStorage.getItem("TP2");
  public TP3: string = window.localStorage.getItem("TP3");
  public T_ID: string = window.localStorage.getItem("T_ID");
  public Prosub_id: any = window.localStorage.getItem("prosub_id");
  @ViewChild("pageBottom") pageTop: IonContent;
  @ViewChild("slider") slider: SwiperComponent;
  public languageCode = "en";
  public preferredCurrency = this.safeLocalStorage.getItem("user_currency") ?? CommonVariable.preferredCurrency ?? "GBP";
  public currencySymbol = "£";
  threeK: number = 3000;
  ticketTimer: number;
  paymentReason = "offer";
  customer_purchase_id: string;
  private remaining: number;
  public payment_done: string;
  private currentNdc: string;
  public paymentReceivedFromCP = false;
  private unsubscribeStatusFromCP$: Subject<void> = new Subject<void>();
  private unsubscribeStatusFromPayment$: Subject<void> = new Subject<void>();
  private destroy$ = new Subject<void>();
  private checkboxListeners: Array<() => void> = [];
  private jackpotNextDrawDateKey = "[count_nearest_draw_date=";
  jackpotSubscription: Subscription;
  public checkOutComData: Data;
  public showCheckOutComSpinner = false;
  public redirectlink: Data;
  public isButtonDisabled: boolean;
  public errorMessage: string;
  public token: string;
  public keys: Data;
  public errorStack: string[] = [];
  public language: string;
  public isCheckoutCom = false;
  public isCheckoutComform = true;
  public customerPurchaseEncryptedId: string;
  private userData: Data;
  private checkoutPaymentSuccess = false;
  public getCheckOutComResponseSubscription: Subscription;
  private cardTokenizedCalled = false;
  private checkoutSessionExpiredHandled = false;
  public WinMoreStatus: boolean;
  public totalPrize$ = new BehaviorSubject(0);
  public checkedValues: number[] = [];
  public checkedValuesDefaultCurrency: number[] = [];
  public addonTotalAmount = 0;
  public totalOfferPrizeValue: number;
  public expiredCardOfferProsubId = "3950";
  private getCheckOutEroor: number;
  private maxCheckOutTries: number;
  paymentSubscription: Subscription;
  insertCustomer4cPaymentPath: string;
  public showAddonList: boolean;
  public fbTokenKey = "fbToken";
  public userIdKey = "userId";
  public wmpTextAdded: boolean = false;
  public isCheckoutResponseReceived: boolean = false;
  tokenValidaterSub: Subscription;
  public upsellID: string = window.localStorage.getItem("ID") ?? "";
  public upsellData: Data;
  public upsellList: Data[];
  public p_id: number;
  private paymentHold = false;
  showHorizonalUpsell: boolean;
  issChecked = signal(false);
  sureText: string = "";
  buttonText: string = "";
  private upsellListSubscription: Subscription;
  private isDestroyed = false;
  /** True once Angular's zone first becomes stable after component init (NgZone.onStable
   *  or 2s fallback). Prevents checkBoxChanged() from calling initializeCheckoutFlowIFrames()
   *  during the synthetic ionChange emitted by ion-checkbox during first-render [(ngModel)]
   *  reconciliation. Does NOT imply pricing amounts are ready — see amountsInitialized.
   *  (LOTTOSOCIAL-PWA-1NBM) */
  private checkboxInitialized = false;
  /** True once the 2s deferred init block has applied preferredCurrency, setDefaultUpsellData,
   *  and addonTotalAmount. initializeCheckoutFlowIFrames() must not be called before this
   *  flag is true, or the Flow session will be created with stale totals. (LOTTOSOCIAL-PWA-1NBM) */
  private amountsInitialized = false;
  /** Tracks that checkBoxChanged() requested a Checkout Flow remount before both
   *  checkboxInitialized and amountsInitialized were true. Executed at the end of the
   *  2s init block once amounts are confirmed ready. (LOTTOSOCIAL-PWA-1NBM) */
  private pendingCheckoutRemount = false;
  /** Handle for the 2s amount-init setTimeout so it can be cancelled in ngOnDestroy,
   *  preventing the closure from being retained unnecessarily after navigation. */
  private amountsInitTimer: ReturnType<typeof setTimeout> | null = null;
  slideToBuyBtnStatus: boolean;
  proSubSlideToBuyStatus: boolean;
  /** Once a stored-card swipe fails on 4C, suppress swipe retry for this page session. */
  private suppressSwipeToBuyAfterFailure = false;
  statusFlag = false;
  fourCPaymentAlert: {
    line1: string;
    line2?: string;
    severity: ToastSeverity;
  } | null = null;
  private networkListener: PluginListenerHandle;
  private _formBuilder = inject(FormBuilder);
  private walletService = inject(WalletService);
  private GTMSegment = inject(GTMSegmentService);
  private paymentService = inject(PaymentService);
  private changeDetRef = inject(ChangeDetectorRef);
  public actRoute = inject(ActivatedRoute);
  private router = inject(Router);
  private utilityService = inject(UtilityService);
  private authService = inject(AuthService);
  public translate = inject(TranslateService);
  private matDialog = inject(MatDialog);
  private loadingService = inject(LoadingService);
  private GTMService = inject(GTMSagmentService); // Typo: GTMSegmentService?
  private storeService = inject(StoreRepositoryService);
  private paymentCardService = inject(PaymentCardService);
  private sanitizer = inject(DomSanitizer);
  public angularFireFunctions = inject(AngularFireFunctions);
  private syndicateDataService = inject(SyndicateDataService);
  private AuthPartialRegService = inject(AuthPartialRegService);
  private renderer = inject(Renderer2);
  private el = inject(ElementRef);
  private ngZone = inject(NgZone);
  private cashPurchaseService = inject(CashPurchaseService);
  private mixPanelService = inject(MixpanelService);
  private paymentDataService = inject(PaymentDataService);
  public userId: string;
  private indexedDBRecovery = inject(IndexedDBRecoveryService);
  private basePaymentService = inject(BasePaymentService)
  private checkoutcomService = inject(CheckoutComService);
  private checkoutFlowService = inject(CheckoutFlowService);
  private resourceLoader = inject(ResourceLoaderService);
  private paymentFlowService = inject(PaymentFlowService);
  private salesJourneyIdentityService = inject(SalesJourneyIdentityService);
  private salesJourneyStateService = inject(SalesJourneyStateService);
  /** Resolved Phase-4 4C state; also exposed for CheckoutComFlowHost consumers. */
  public fourCJourneyState: FourCJourneyStateResult | null = null;
  private cmsPlayNowUnlisten: (() => void) | null = null;
  private checkoutFramesInitFrame: number | null = null;
  private checkoutFramesInitCancelled = false; 
  private formSelectedCardInterval: ReturnType<typeof setInterval> | null = null;
  private formSelectedCardSubscription: Subscription;
  private checkoutIframeActivationInterval: ReturnType<typeof setInterval> | null = null;
  private checkoutIframeRetryTimer: ReturnType<typeof setTimeout> | null = null;
  private checkoutIframeReloadTimer: ReturnType<typeof setTimeout> | null = null;
  private checkoutIframeRetryAttempted = false;
  private readonly checkoutIframeReloadGuardKey = "checkout_4c_iframe_reload_used";
  private successBannerHideTimer: ReturnType<typeof setTimeout> | null = null;
  private successBannerScheduleTimer: ReturnType<typeof setTimeout> | null = null;
  private commonServiceLocal = inject(CommonService);
  public paymilPaymentService = inject(PaymilPaymentService);
  private cardUpsellService = inject(CardUpsellService);
  private paymentNavigationService = inject(PaymentNavigationService);
  private authStateService = inject(AuthStateService);
  private checkoutFlowRedirectHandled = false;
  public toastFacade = inject(ToastFacadeService);
  private jackpotDisplayHelper = inject(JackpotDisplayHelper);
  showVisaInfoHTML = "";
  isStickyCTAEnabled: boolean;
  private checkoutFramesInitSeq = 0;
  private checkoutFramesInitializing = false;
  /** Blocks duplicate partial_Reg when query params re-fire after navigation-state init. */
  private navigationStateHandled = false;
  /** Tracks which prosub_id content is currently rendered (same-route param changes must reload). */
  private lastLoadedProsubId: string | null = null;
  constructor(private angularFireAuth: AngularFireAuth, protected firestore: Firestore) {
    super(angularFireAuth, firestore);

    // Defensive check to prevent third-party scripts from accessing window.__firefox__ in non-Firefox browsers
    // This prevents TypeError when payment gateway scripts check for Firefox-specific APIs
    if (typeof window !== 'undefined' && !window.__firefox__) {
      // Create a proxy object that safely handles property access attempts
      window.__firefox__ = new Proxy({}, {
        get: function () {
          // Return undefined for any property access instead of throwing an error
          return undefined;
        }
      });
    }

    // Wrap initialization in try-catch to handle IndexedDB corruption errors
    try {
      this.initializeDefaults();
      this.subscribeToLanguage();
      this.subscribeToUserDetails();
      this.handleSignupFailure();
      this.fetchToastMessages();
      this.processNavigationState();
      this.processQueryParams();
      this.configureStoredCardsWatcher();
      this.fetchProsubDetailsForSlideToBuy();
      if (window?.wpwlOptions) {
        window.wpwlOptions.locale = this.selectedLanguage ?? "en";
      }
      this.paymilPaymentService.removePaymentHeaderFromIframe();
    } catch (error) {
      // Check if this is an IndexedDB corruption error
      if (this.indexedDBRecovery.isIndexedDBCorruptionError(error)) {
        this.authService.errorHandlerLogs('IndexedDB corruption detected during payment page initialization:', error);
        this.indexedDBRecovery.handleCorruptionAndReload().catch(err => {
          this.authService.errorHandlerLogs('Failed to recover from IndexedDB corruption:', err);
        });
      } else {
        // Re-throw non-corruption errors
        throw error;
      }
    }
  }
  private configureStoredCardsWatcher(): void {
    this.basePaymentService
      .configureStoredCardsWatcher(this.userId)
      .subscribe((res) => {
        this.slideToBuyBtnStatus = res ?? false;
      });
  }
  private processQueryParams(): void {
    let pageData = this.router.getCurrentNavigation()?.extras?.state;
    this.actRoute.queryParamMap.subscribe(
      (params: Data) => {
        this.authService.prosub = params;
        // URL keys may be lowercased by partial-reg normalization (tp1/tp2/other).
        // Read case-insensitively so fresh query params overwrite stale localStorage.
        const qp = params?.params || {};
        const getQp = (name: string) =>
          qp[Object.keys(qp).find((key) => key?.toLowerCase() === name)];
        const TP1 = getQp("tp1");
        const TP2 = getQp("tp2");
        const TP3 = getQp("tp3");
        const T_ID = getQp("t_id");
        const Other = getQp("other");
        if (TP1) {
          localStorage.setItem("TP1", TP1);
          this.TP1 = TP1;
        }
        if (params?.params?.upsell_ID) {
          this.upsellID = params.params.upsell_ID;
          localStorage.setItem("upsellID", this.upsellID);
        }
        if (TP2) {
          localStorage.setItem("TP2", TP2);
          this.Tp2 = TP2;
        }
        if (TP3) {
          localStorage.setItem("TP3", TP3);
          this.TP3 = TP3;
        }
        if (T_ID) {
          localStorage.setItem("T_ID", T_ID);
          this.T_ID = T_ID;
        }
        if (Other) {
          localStorage.setItem("Other", Other);
        }

        const prosubId = params.params?.prosub_id || params.params?.Prosub_ID;
        if (prosubId) {
          this.paymentProsubId = prosubId;
          localStorage.setItem("prosub_id", this.paymentProsubId);
        } else {
          this.paymentProsubId = null;
        }

        if (pageData) {
          pageData = null;
        }

        if (!prosubId) {
          return;
        }

        const prosubChanged = String(prosubId) !== String(this.lastLoadedProsubId ?? "");
        if (this.navigationStateHandled && !prosubChanged) {
          return;
        }

        if (prosubChanged) {
          this.navigationStateHandled = false;
          this.isOfferCapped = false;
          this.loaded = false;
        }

        this.isCappingCheckDone = false;
        this.loadingService.present();
        this.addingCard = false;
        this.isPaymentDone = false;
        this.spinnerAnimation = false;
        this.addNewCardInProgress = false;
        const partialRegLocale = {
          language: this.selectedLanguage || this.safeLocalStorage.getItem("language_code") || "en",
          currency: this.preferredCurrency || this.safeLocalStorage.getItem("user_currency") || "GBP",
        };
        this.AuthPartialRegService.partial_Reg(prosubId, "", "", "full", partialRegLocale).subscribe({
          next: (s) => {
            const hasPaymentContent =
              !!s?.paymentHtml || !!normalizeGetRegOptMsgHtml(s?.getRegOptMsgHtml);
            if (!s || s.error || !hasPaymentContent) {
              this.loadingService.dismiss();
              this.router.navigate(["/partial-registration"], { queryParams: params.params });
              return;
            }

            this.lastLoadedProsubId = String(prosubId);
            this.applyPartialRegCurrencyContext(s);
            this.paymentPageData = this.preparePaymentPageHtml(s);
            this.checkSyndicateIsWMP();
            if (
              typeof this.paymentPageData === "string" &&
              this.paymentPageData.includes(this.jackpotNextDrawDateKey)
            ) {
              this.fetchJackpotData();
            }

            this.loadingService.dismiss();
            this.isCappingCheckDone = true;

            if (s) {
              this.altprosubDetails = s?.prosubDetail;
              this.purchaseDetail = this.paymentService?.formPaymentDataForTopUp(this.altprosubDetails);
              this.showHorizonalUpsell = this.purchaseDetail?.offers?.horizontal_upsells === "yes";
              this.setPurchaseDetailInLocalStorage(this.purchaseDetail);

              this.paymentService
                .getPTypeByOffer(this.p_id)
                .pipe(take(1))
                .subscribe((currencySnap: any) => {
                  if (!currencySnap || typeof currencySnap.data !== 'function') {
                    // Offline or invalid snapshot — apply safe default p_type
                    if (this.purchaseDetail && this.purchaseDetail.p_type == null) {
                      this.purchaseDetail.p_type = 21;
                    }
                    return;
                  }
                  const currencyData = currencySnap.data(); // 👈 this is the actual document data
                  const allProsub = currencyData?.prosubs;
                  const prosub = allProsub?.filter((prosub) => prosub === this.purchaseDetail.prosub_id);

                  if (this.purchaseDetail && this.purchaseDetail.p_type == null) {
                    this.purchaseDetail.p_type = 21;
                  }
                });

              this.modifyAddonContent();

              this.AuthPartialRegService.check4cFlow(s?.prosubDetail.prosub_id).subscribe(
                (r) => {
                  // Guard against null response from check4cFlow
                  if (!r) {
                    this.authService.errorHandlerLogs("check4cFlow returned null in processQueryParams");
                    // Initialize storedCards as empty array to prevent null reference errors
                    this.storedCards = [];
                    this.markPageLoaded();
                    this.isCappingCheckDone = true;
                    this.matDialog.closeAll();
                    return;
                  }

                  // Validate storedCards data before calling getDistinctCards
                  // Pass empty array if storedCards is null/undefined to prevent null reference errors
                  const storedCardsData = r?.storedCards ?? [];
                  this.getDistinctCards(storedCardsData);
                  this.markPageLoaded();
                  this.afterFourCData(r);
                  this.matDialog.closeAll();

                  if (r?.purchaseCapping?.paymentCappingSyndicateId && !r?.purchaseCapping?.goodForPayment) {
                    this.isCappingCheckDone = false;
                  } else {
                    this.isCappingCheckDone = true;
                  }

                  this.maybeTriggerNoCardFallbackAfterCapping();
                },
                (err) => {
                  this.authService.errorHandlerLogs("check4cFlow error in processQueryParams:", err);
                  // Initialize storedCards as empty array to prevent null reference errors
                  this.storedCards = [];
                  this.markPageLoaded();
                  this.isCappingCheckDone = true;
                  this.matDialog.closeAll();
                  return err;
                }
              );

              this.fourCPaymentResponse = s;
              this.loadingService.dismiss();
              this.loadingService.hasRenderedSignal.set(true);
              this.markPageLoaded();
            }
          },
          error: (error) => {
            this.loadingService.dismiss();
            return error;
          },
        });

        return;
      },
      (err) => {
        return err;
      }
    );
  }

  private processNavigationState(): void {
    let pageData = this.router.getCurrentNavigation().extras?.state;
    if (pageData) {
      this.navigationStateHandled = true;
      if (pageData?.prosubDetail?.prosub_id) {
        this.lastLoadedProsubId = String(pageData.prosubDetail.prosub_id);
      }

      this.altprosubDetails = pageData?.prosubDetail;
      this.purchaseDetail = this.paymentService?.formPaymentDataForTopUp(this.altprosubDetails);
      this.setPurchaseDetailInLocalStorage(this.purchaseDetail);
      this.modifyAddonContent();
      this.AuthPartialRegService.check4cFlow(pageData?.prosubDetail.prosub_id).subscribe(
        (r) => {
          this.loadingService.isLodingSignal.set(true);
          this.loadingService.dismiss();
          this.loadingService.hasRenderedSignal.set(true);

          // Guard against null response from check4cFlow
          if (!r) {
            this.authService.errorHandlerLogs("check4cFlow returned null in processNavigationState");
            // Initialize storedCards as empty array to prevent null reference errors
            this.storedCards = [];
            this.isCappingCheckDone = true;
            this.matDialog.closeAll();
            return;
          }

          // Validate storedCards data before calling getDistinctCards
          // Pass empty array if storedCards is null/undefined to prevent null reference errors
          const storedCardsData = r?.storedCards ?? [];
          this.getDistinctCards(storedCardsData);
          this.afterFourCData(r);
          this.matDialog.closeAll();
          // this.isCappingCheckDone = true;
          if (r?.purchaseCapping?.paymentCappingSyndicateId && !r?.purchaseCapping?.goodForPayment) {
            this.isCappingCheckDone = false;
          } else {
            this.isCappingCheckDone = true;
          }

          this.maybeTriggerNoCardFallbackAfterCapping();
        },
        (err) => {
          this.authService.errorHandlerLogs("check4cFlow error in processNavigationState:", err);
          // Initialize storedCards as empty array to prevent null reference errors
          this.storedCards = [];
          this.loadingService.dismiss();
          this.isCappingCheckDone = true;
          this.matDialog.closeAll();
          return err;
        }
      );
      this.fourCPaymentResponse = pageData;
      this.applyPartialRegCurrencyContext(pageData);
      this.paymentPageData = this.preparePaymentPageHtml(pageData);
      this.checkSyndicateIsWMP();
      this.markPageLoaded();
      if (this.paymentPageData?.includes(this.jackpotNextDrawDateKey)) {
        this.fetchJackpotData();
      }
    }
  }

  /**
   * Prefer effectiveLocale from partialregv2 over a stale localStorage currency.
   * Fixes UK affiliate journeys where paymentHtml can arrive with `$` while locale is GBP.
   */
  private applyPartialRegCurrencyContext(pageData: Data): void {
    const localeCurrency =
      pageData?.effectiveLocale?.currency ||
      pageData?.userDefaults?.currency ||
      null;
    if (!localeCurrency) {
      return;
    }
    this.preferredCurrency = String(localeCurrency).toUpperCase();
    this.currencySymbol = getDefaultCurrencySymbol(this.preferredCurrency);
    this.safeLocalStorage.setItem("user_currency", this.preferredCurrency);
  }

  /** Bind payment HTML aligned to effectiveLocale; add lazy-load attrs for images. */
  private preparePaymentPageHtml(pageData: Data): string {
    const html = resolveLocaleAlignedPaymentHtml(pageData, this.preferredCurrency || "GBP");
    if (!html) {
      return html;
    }
    return html.replace(/<img([^>]*)>/g, `<img$1 decoding="async" loading="lazy">`);
  }
  private fetchToastMessages(): void {
    this.authService.getConstantsMsg$.subscribe((msg: any) => {
      this.translatedToastMsg = msg?.static_messages_pwa;
    });
  }

  private fetchProsubDetailsForSlideToBuy(): void {
    // Get Prosub details for slide to buy
    const urlParams = new URLSearchParams(window.location.search);
    const prosubId = new URLSearchParams(window.location.search).get("prosub_id");
    const docRef = doc(this.firestore, `/general_modules/prosub_id/${prosubId}/details`);

    getDoc(docRef).then((details) => {
      if (details.exists()) {
        const data = details.data() as Data;
        this.isStickyCTAEnabled = data?.isStickyCTAEnabled ?? false;
        this.proSubSlideToBuyStatus = data?.slide_to_buy_show ?? false;
        this.changeDetRef?.detectChanges();
      }
    }).catch((err) => {
      // Check if this is an IndexedDB corruption error
      if (this.indexedDBRecovery.isIndexedDBCorruptionError(err)) {
        this.authService.errorHandlerLogs("IndexedDB corruption detected while fetching prosub details:", err);
        this.indexedDBRecovery.handleCorruptionAndReload().catch(recoveryErr => {
          this.authService.errorHandlerLogs("Failed to recover from IndexedDB corruption:", recoveryErr);
        });
      } else {
        this.authService.errorHandlerLogs("Error fetching prosub details:", err);
      }
    });
  }

  private initializeDefaults(): void {
    this.paymentReason = "offer";
    this.upsellList = [];
    this.p_id = 21;
    this.getCheckOutEroor = 0;
    this.totalOfferPrizeValue = 0;
    this.insertCustomer4cPaymentPath = "insert_customer_purchase_4c_payment";
    this.maxCheckOutTries = 4;
    this.isButtonDisabled = true;
    this.loaded = false;
    this.loaded = false;
    this.GTMSegment?.GTMInitilization();
  }

  private subscribeToLanguage(): void {
    this.authService.selectedlanguage$.pipe(filter(Boolean), take(1)).subscribe((lang) => {
      const finalLang = CommonVariable.bypassLanguages.includes(lang) ? "en" : lang;
      this.selectedLanguage = finalLang;
      this.translate.use(finalLang);
      this.language = this.mapLangToCode(finalLang);
      if (window?.wpwlOptions) window.wpwlOptions.locale = finalLang;
    });
  }

  private mapLangToCode(lang: string): string {
    const map = {
      en: "EN-GB",
      de: "DE-DE",
      es: "ES-ES",
      fr: "FR-FR",
      it: "IT-IT",
    };
    return map[lang] || "EN-GB";
  }

  private subscribeToUserDetails(): void {
    this.authService.userDetails$.pipe(filter(Boolean), take(1)).subscribe((user: Data) => {
      this.userData = user;
      this.languageCode = user?.language_code || "en";
      this.preferredCurrency = this.safeLocalStorage.getItem("user_currency") || user?.preferred_currency || "GBP";

      this.translate.use(CommonVariable.bypassLanguages.includes(this.languageCode) ? "en" : this.languageCode);

      this.authService.getCurrencyList$.pipe(take(1)).subscribe((data: Data) => {
        const match = data?.details?.find((x: Data) => x?.currency_code === this.preferredCurrency);
        this.currencySymbol = match?.currency_symbol || "£";
      });
    });
  }

  private handleSignupFailure(): void {
    this.authService.callSigUpForSalesResponse$.pipe(filter(Boolean)).subscribe((d) => {
      // Keep Phase-4 state in sync when signup status changes (pending → failed/success).
      this.applyFourCJourneyState(this.fourCPaymentResponse ?? null);

      if (location.href.includes("free-reg-step4c") && d?.response?.status === "FAIL") {
        const proSub = localStorage.getItem("prosub_id");
        this.authService.logout().then(() => {
          if (!proSub) return;
          this.router.navigateByUrl(`partial-registration?prosub_id=${proSub}`);
          const msg =
            d?.response?.message === "MSN_INVALID"
              ? "Registration failed, please enter a correct phone number."
              : undefined;
          this.authService.showAnonymousUserMessage(msg);
        });
      }
    });
  }

  // Get win more status and add additional description for WMP
  public checkSyndicateIsWMP() {
    this.syndicateDataService
      .GetWinMorePromise()
      .pipe(
        catchError((err) => {
          // Log the error but return null Observable instead of throwing to maintain stream contract
          this.authService.errorHandlerLogs('[checkSyndicateIsWMP] Error fetching win more promise data:', err);
          return of(null);
        })
      )
      .subscribe((res: Data) => {
        try {
           // Guard against null response to prevent errors accessing properties
          if (!res) {
            this.authService.errorHandlerLogs('[checkSyndicateIsWMP] Received null response from GetWinMorePromise');
            return;
          }
          this.WinMoreStatus = res?.win_more_promise;
          if (this.WinMoreStatus === true && !this.wmpTextAdded) {
            this.wmpTextAdded = true;
            this.paymentPageData = this.paymentPageData.replace("</ul>", "<li>14 Day Win More Promise</li></ul>");
          }
        } catch (err) {
          this.authService.errorHandlerLogs('[checkSyndicateIsWMP] Error processing win more promise data:', err);
          return err;
        }
      });
  }

  // This function is used for 4c page payment flow
  private afterFourCData(r: any) {
    // Guard against null response from check4cFlow (e.g., due to Firebase permission errors)
    if (!r) {
      this.authService.errorHandlerLogs("afterFourCData received null response from check4cFlow");
      this.isCappingCheckDone = true;
      return;
    }
    this.applyFourCJourneyState(r);
    if (r?.offerCapping) {
      this.isOfferCapped =
        r.offerCapping?.cappingStatus === true ||
        r.offerCapping?.capping_status === true;
      if (this.isOfferCapped) {
        this.paymentNavigationService.handleNavigationForOfferCapping(r);
      }
      if (r?.offerCapping.offerId) {
        this.offer_id = r.offerCapping.offerId;
      }
      this.processcustomer_offer = r?.offerCapping?.alternateOfferId;
    }
    if (!r?.purchaseCapping?.goodForPayment) {
      if (r?.purchaseCapping?.paymentCappingSyndicateId) {
        this.paymentNavigationService.handlePurchaseCapping(r, this.userId);
      }
    } else {
      this.isCappingCheckDone = true;
    }
  }

  /**
   * Wires SalesJourneyStateService into the active 4C readiness path using
   * PaymentService.buildFourCStateInputFromResponse (pending/failed reconciliation UX).
   */
  private applyFourCJourneyState(fourCResponse: Data | null): void {
    const auth = getAuth();
    const signupStatus =
      this.authService.callSigUpForSalesResponse$?.value?.response?.status ?? null;
    const input = this.paymentService.buildFourCStateInputFromResponse(fourCResponse, {
      isAnonymous: !!auth?.currentUser?.isAnonymous,
      signupStatus,
    });
    this.fourCJourneyState = this.salesJourneyStateService.resolve(input);

    if (
      this.fourCJourneyState?.state === "identity_reconciliation_failed" &&
      this.fourCJourneyState.blockedReason
    ) {
      void this.showFourCAlertByConstantsCode(
        "1026",
        this.fourCJourneyState.blockedReason,
        "error"
      );
    }
  }

  // This function is a helper function to scroll the page down to the
  // "Scroll Down" button on the home page.  public pageScroller() {
  public pageScroller() {
    window.scrollTo({
      top: 1500,
      behavior: "smooth",
    });
  }

  /* This is the function to get distinct cards from the stored cards. */
  private getDistinctCards(paymentDetails: Data) {
    try {
      this.loadingService.isLodingSignal.set(true);
      this.loadingService.dismiss();

      if (!Array.isArray(paymentDetails) || paymentDetails.length === 0) {
        this.handleNoStoredCard();
        return [];
      }
      this.storedCards = this.walletService.getFilteredWalletCards(paymentDetails) ?? [];

      const allOngoingFalse = localStorage.getItem('allOngoingFalse') === 'true';
      if (allOngoingFalse) {
        this.translate.get(["payment"]).subscribe((res) => {
          this.showVisaInfoHTML = `<div class="info-banner">
              <span class="info-icon">ℹ️</span>
              <p>${res["payment"]["visa_nudge"]}</p>
            </div>`;
        });
      }

      if (this.storedCards?.length > 0) {
        this.showAddNewCard = true;
        this.storedCards[0].isChecked = true;
      }
      if (!this.storedCards.length) {
        this.handleNoStoredCard();
        return [];
      }

      // Limit visible cards for UI performance - use optional chaining
      this.showAll = !(this.storedCards?.length > 2);

      // Process distinct cards
      let distinct = [];
      [distinct, this.storedCards, this.selectedCard] = this.paymentCardService?.getDistinctCards(this.storedCards);

      // Dismiss loader here to show cards as soon as they're ready
      this.loadingService.dismiss();

      // Return the distinct cards
      return distinct;
    } catch (error) {
      this.loadingService.dismiss();
      // Initialize storedCards as empty array on error to prevent null reference errors
      this.storedCards = [];
      // HATDEV-99039: keep Add New Card recoverable when card parsing fails
      this.showAddNewCard = true;
      return [];
    }
  }

  @HostListener("window:message", ["$event"])
  onMessage(e: MessageEvent): void {
    try {
      const allowedOrigins: string[] = [];
      // Safely extract origin from environment URL
      try {
        if (environment?.paymentWidgetUrl) {
          allowedOrigins.push(new URL(environment.paymentWidgetUrl).origin);
        }
      } catch (err) {
        this.authService.errorHandlerLogs("Invalid paymentWidgetUrl in environment", err);
      }

      allowedOrigins.push(window.location.origin);

      if (!allowedOrigins.includes(e.origin)) {
        this.authService.errorHandlerLogs(`Blocked postMessage from unauthorized origi : ${e.origin}`);
        return;
      }

      if (e?.data?.for === "paymentDone") {
        this.afterNewCardPaymentDone();
      }
    } catch (err) {
      this.authService.errorHandlerLogs("Error handling message event", err);
    }
  }

  ngOnDestroy() {
    this.isDestroyed = true;
    if (this.amountsInitTimer !== null) {
      clearTimeout(this.amountsInitTimer);
      this.amountsInitTimer = null;
    }
    this.cleanupCheckboxListeners();
    if (this.cmsPlayNowUnlisten) {
      this.cmsPlayNowUnlisten();
      this.cmsPlayNowUnlisten = null;
    }
    if (this.successBannerScheduleTimer) {
      clearTimeout(this.successBannerScheduleTimer);
      this.successBannerScheduleTimer = null;
    }
    if (this.successBannerHideTimer) {
      clearTimeout(this.successBannerHideTimer);
      this.successBannerHideTimer = null;
    }
    this.isDestroyed = true;
    this.checkoutFramesInitializing = false;
    this.destroy$.next();
    this.destroy$.complete();
    this.safeLocalStorage.removeItem("4cpage");
    if (this.formSelectedCardInterval !== null) {
      clearInterval(this.formSelectedCardInterval);
      this.formSelectedCardInterval = null;
    }
    this.paymentSubscription?.unsubscribe();
    this.formSelectedCardSubscription?.unsubscribe();
    this.tokenValidaterSub?.unsubscribe();
    this.upsellListSubscription?.unsubscribe();
    this.jackpotSubscription?.unsubscribe();
    this.getCheckOutComResponseSubscription?.unsubscribe();
    this.unsubscribeStatusFromCP$?.complete();
    this.unsubscribeStatusFromPayment$?.complete();
    this.totalPrize$?.complete();
    this.cancelCheckoutFramesInit();
    this.clearCheckoutIframeRecovery();
    this.checkoutFlowService.releaseHost(this.asCheckoutFlowHost());
    this.checkoutcomService.cancelRetries();
    this.basePaymentService.dispose();
  }

  ngAfterViewInit(): void {
    // Both phases are scheduled outside Angular's zone so their pending macro-tasks do
    // not keep NgZone unstable. If run inside the zone, Angular would see pending async
    // work and NgZone.onStable would not fire until the 2s timers complete — defeating
    // the purpose of the race. State mutations re-enter the zone via ngZone.run().
    // (LOTTOSOCIAL-PWA-1NBM)
    this.ngZone.runOutsideAngular(() => {

      // Phase 1 — flip checkboxInitialized once Angular's zone is first stable so that
      // real user checkbox interactions are no longer treated as synthetic first-render
      // events. NgZone.onStable fires milliseconds after the first render once all
      // in-zone work has settled. timer(2000) is a fallback only; because this
      // subscription is outside the zone the timer itself does not delay onStable.
      // takeUntil(destroy$) prevents callbacks after component destruction.
      // NOTE: amountsInitialized remains false here — do NOT remount Checkout iframes yet.
      race(
        this.ngZone.onStable.pipe(take(1)),
        timer(2000)
      ).pipe(takeUntil(this.destroy$), take(1)).subscribe(() => {
        this.ngZone.run(() => {
          if (!this.isDestroyed) {
            this.checkboxInitialized = true;
          }
        });
      });

      // Phase 2 — apply preferredCurrency, default upsell data, and addonTotalAmount.
      // Only after this block runs are totals reliable enough to create a Checkout Flow
      // session. pendingCheckoutRemount is consumed here (with a full condition re-check)
      // so iframes are always remounted with correct amounts.
      // Scheduled outside the zone so the pending 2s macro-task does not block onStable.
      // Timer handle is stored so ngOnDestroy can cancel the closure immediately on destroy.
      this.amountsInitTimer = setTimeout(() => {
        this.amountsInitTimer = null;
        this.ngZone.run(() => {
          if (this.isDestroyed) { return; }
          let amountsApplied = false;
          try {
            this.preferredCurrency = this.safeLocalStorage.getItem("user_currency") || this.preferredCurrency || "GBP";
            // To set the initial amount for upsell & total amount if any offer is selected by default
            this.setDefaultUpsellData();
            // Resolve offer price — treat empty string as absent so it falls back to
            // offers.price (Number("") === 0 and would pass Number.isFinite, masking the
            // real price if int_price[currency] is an empty string from the backend).
            const intPriceRaw = this.purchaseDetail?.offers?.int_price?.[this.preferredCurrency];
            const offerPriceRaw = this.purchaseDetail?.offers?.price;
            const intPrice = (intPriceRaw != null && intPriceRaw !== '') ? intPriceRaw : null;
            const offerPrice = (offerPriceRaw != null && offerPriceRaw !== '') ? offerPriceRaw : null;
            const rawOfferPrize = intPrice ?? offerPrice ?? 0;
            // Normalize to a safe finite number — guard against NaN or non-numeric values.
            // Log a warning when rawOfferPrize is non-empty but non-numeric so backend
            // data issues are visible in Sentry rather than silently becoming 0.
            const parsedOfferPrize = Number(rawOfferPrize);
            if (rawOfferPrize !== 0 && !Number.isFinite(parsedOfferPrize)) {
              this.authService.errorHandlerLogs('[PaymentPage] non-numeric offerPrize, defaulting to 0', rawOfferPrize);
            }
            const safeOfferPrize = Number.isFinite(parsedOfferPrize) ? parsedOfferPrize : 0;
            // Preserve the original behavior: mutate totalOfferPrizeValue to 0 when it is
            // undefined/non-numeric so that downstream code reading this property sees a
            // defined numeric value (regression guard — original code did the same).
            if (!Number.isFinite(Number(this.totalOfferPrizeValue))) {
              this.totalOfferPrizeValue = 0;
            }
            const safeTotalOffer = Number(this.totalOfferPrizeValue);
            // Round the FINAL sum (not just safeTotalOffer) to avoid floating-point
            // artifacts leaking into addonTotalAmount via safeOfferPrize addition.
            const totalPrize = Number((safeTotalOffer + safeOfferPrize).toFixed(2));
            this.addonTotalAmount = totalPrize;
            // this.totalPrize$.next(totalPrize);
            // Mark amounts as successfully applied immediately after addonTotalAmount is set,
            // BEFORE the follow-up UI calls (updateAddonDataForPaymilPayment etc.). This
            // ensures a throw in a non-amount UI call does not leave amountsInitialized=false
            // permanently, blocking all subsequent checkbox-triggered remounts. (LOTTOSOCIAL-PWA-1NBM)
            amountsApplied = true;
            this.updateAddonDataForPaymilPayment(this.purchaseDetail?.addons ?? []);
            this.checkStickyUiForProsub();
            this.getCheckBoxValue();
          } catch (error) {
            this.authService.errorHandlerLogs('[PaymentPage] ngAfterViewInit amounts init error', error);
          } finally {
            // checkboxInitialized is always flipped so the synthetic-event window closes
            // regardless of whether amounts succeeded or failed.
            this.checkboxInitialized = true;
            if (amountsApplied) {
              // Amounts were successfully applied (addonTotalAmount is reliable).
              // Set amountsInitialized before processing the pending remount so that
              // initializeCheckoutFlowIFrames() runs with the gate already open.
              this.amountsInitialized = true;
              // Honour any deferred remount now that amounts are confirmed correct.
              // Placed in finally so a throw from a post-amount UI call (updateAddon...,
              // checkSticky..., getCheckBox...) cannot skip this path. (LOTTOSOCIAL-PWA-1NBM)
              // Wrapped in its own try/catch so a remount failure leaves pendingCheckoutRemount
              // set, allowing a retry on the next user toggle.
              if (
                this.pendingCheckoutRemount &&
                this.isCheckoutComform &&
                this.keys?.publicKey &&
                !this.cardTokenizedCalled
              ) {
                try {
                  this.initializeCheckoutFlowIFrames();
                  this.pendingCheckoutRemount = false; // clear only on success
                } catch (remountError) {
                  this.authService.errorHandlerLogs('[PaymentPage] pending remount failed', remountError);
                  // pendingCheckoutRemount stays true — next user toggle will retry
                }
              }
            }
            // On failure (amountsApplied=false): amountsInitialized stays false and
            // pendingCheckoutRemount stays set. checkBoxChanged() (case 2) keeps deferring
            // real user interactions, preventing remounts with stale or partial totals.
          }
        });
      }, 2000);

    });
  }

  private markPageLoaded(): void {
    this.loaded = true;
    this.scheduleSuccessBannerHide();
    // CMS "Play Now" in paymentPageData (red header CTA) must use same capping toast as Pay Now
    this.bindCmsPlayNowClick();
  }

  /**
   * Wire CMS .play-btn (header Play Now) to proceedToPay so capping_status toast shows there too.
   * Angular Pay Now already calls proceedToPay from the template.
   */
  private bindCmsPlayNowClick(): void {
    if (this.cmsPlayNowUnlisten) {
      this.cmsPlayNowUnlisten();
      this.cmsPlayNowUnlisten = null;
    }

    setTimeout(() => {
      if (this.isDestroyed) {
        return;
      }
      const playButton = this.el?.nativeElement?.querySelector?.(".play-btn");
      if (!playButton) {
        return;
      }
      this.cmsPlayNowUnlisten = this.renderer.listen(playButton, "click", (event: Event) => {
        event.preventDefault();
        event.stopPropagation();
        void this.proceedToPay();
      });
    }, 0);
  }

  private scheduleSuccessBannerHide(): void {
    if (this.successBannerScheduleTimer) {
      clearTimeout(this.successBannerScheduleTimer);
      this.successBannerScheduleTimer = null;
    }
    if (this.successBannerHideTimer) {
      clearTimeout(this.successBannerHideTimer);
      this.successBannerHideTimer = null;
    }

    this.successBannerScheduleTimer = setTimeout(() => {
      this.successBannerScheduleTimer = null;
      if (this.isDestroyed) {
        return;
      }
      this.successBannerHideTimer = scheduleSuccessBannerHideTimer(
        this.el?.nativeElement,
        this.paymentPageData
      );
    }, 0);
  }
  ngOnInit() {
    this.startJourney();
    this.authService
      ?.getUid("PaymentPage")
      ?.then((uid) => {
        if (uid) {
          this.userId = uid;
        }
      })
      .catch((error) => {
        return error;
      });
    const qp = this.actRoute.snapshot?.queryParams ?? {};
    this.preferredCurrency = this.safeLocalStorage.getItem("user_currency") || this.preferredCurrency || "GBP";
    this.paymentMode = qp.pt ?? "";
    this.checkoutEvent = qp.cko_event ?? null;
    this.getUpsellData(this.upsellID);
    // Essential UI initialization (immediate)
    this.GTMSegment.collectVisitorData();
    this.payment_done = "";
    this.GTMSegment.GTM_4c_page();

    // Set up form controls (immediate)
    this.firstFormGroup = this._formBuilder.group({
      firstCtrl: ["", Validators.required],
    });
    // Handle checkout flow redirect
    this.handleCheckoutFlowRedirect();
    // Initialize network monitoring (non-blocking)
    this.setupNetworkMonitoring();

    // Process page flow based on 3DS state (immediate)
    this.handleRedirectionFlow();

    // Initialize redirect URL synchronously (doesn't return a value)
    this.initializeRedirectUrl();

    // Create observables for parallel data loading
    // Ensure all values are valid observables - never undefined
    const translationDataObs = this.translate.get(["no-thanks-popup"]);
    const upsellDataObs = this.upsellID && this.upsellID.length > 0
      ? this.paymentService.getUpsellList(this.upsellID).pipe(
          catchError((error) => {
            this.authService.errorHandlerLogs('Error loading upsell data:', error);
            return of(null);
          })
        )
      : of(null);

    const essentialDataObservables = {
      translationData: translationDataObs,
      upsellData: upsellDataObs,
    };

    // Combine essential data streams with combineLatest
    // Guard against undefined observables by ensuring all values are valid Observables
    if (translationDataObs && upsellDataObs) {
      combineLatest(essentialDataObservables)
        .pipe(
          take(1),
          catchError((error) => {
            // Handle any unexpected errors in the observable chain
            this.authService.errorHandlerLogs('Error in combineLatest for essential data:', error);
            this.authService.errorHandlerLogs('Error loading essential payment data:', error);
            return of(null);
          })
        )
        .subscribe(
          ({ translationData }) => {
            if (translationData) {
              this.processTranslationData(translationData);
            }

            // Start loading non-critical data
            this.loadNonEssentialData();
          }, error => {
            this.authService.errorHandlerLogs('Error loading essential payment data:', error);
            // Handle error gracefully - continue without blocking page load
            this.loadNonEssentialData();
          });
    } else {
      // Fallback if observables are somehow invalid
      this.authService.errorHandlerLogs('Essential data observables are invalid, proceeding with fallback');
      this.loadNonEssentialData();
    }

    // Start timer outside Angular zone
    // Avoid a hard reload while checkout.com is still initialising (common on anonymous flow).
    this.ngZone.runOutsideAngular(() => {
      setTimeout(() => {
        if (!this.loadingService.hasRenderedSignal() && !this.addingCard && !this.checkoutFramesInitializing) {
          location.reload();
        }
      }, 5000);
    });
    this.isCheckoutCom = true;
    this.paymentDataService.getCheckoutDetails();
  }

  // slide btn start
  onSliderTouchStart(event: TouchEvent) {
    if (!event?.touches?.length) return;
    this.startDrag(event.touches[0].clientX);
  }

  onSliderTouchMove(event: TouchEvent) {
    if (!event?.touches?.length) return;
    if (this.isDragging) {
      event.preventDefault();
    }
    this.drag(event.touches[0].clientX);
  }

  onSliderMouseDown(event: MouseEvent) {
    event.preventDefault();
    this.startDrag(event.clientX);
  }

  @HostListener("document:mousemove", ["$event"])
  onDocumentMouseMove(event: MouseEvent) {
    this.drag(event.clientX);
  }

  @HostListener("document:mouseup")
  onDocumentMouseUp() {
    this.endDrag();
  }

  @HostListener("document:touchmove", ["$event"])
  onDocumentTouchMove(event: TouchEvent) {
    if (!this.isDragging || !event?.touches?.length) return;
    event.preventDefault();
    this.drag(event.touches[0].clientX);
  }

  @HostListener("document:touchend")
  onDocumentTouchEnd() {
    this.endDrag();
  }

  @HostListener("document:touchcancel")
  onDocumentTouchCancel() {
    this.endDrag();
  }

  isSlideInteractionDisabled(): boolean {
    return this.slideLocked || this.isActivated || this.spinnerAnimation || !this.proceed;
  }

  private getSliderMaxOffset(): number {
    const sliderEl = this.slide_btn?.nativeElement as HTMLElement | undefined;
    const containerEl = sliderEl?.parentElement as HTMLElement | null;
    if (sliderEl && containerEl) {
      const dynamicOffset = containerEl.clientWidth - sliderEl.clientWidth - 8;
      this.maxOffset = Math.max(80, dynamicOffset);
    }
    return this.maxOffset;
  }

  startDrag(startPosition: number) {
    if (this.isSlideInteractionDisabled()) return;
    this.getSliderMaxOffset();
    this.isDragging = true;
    this.startX = startPosition;
  }

  drag(currentX: number) {
    if (!this.isDragging || this.isSlideInteractionDisabled()) return;
    const deltaX = currentX - this.startX;
    const newX = Math.max(5, Math.min(deltaX, this.getSliderMaxOffset()));
    this.currentSliderX = newX;
    this.slide_btn?.nativeElement?.style?.setProperty("transform", `translateX(${newX}px)`);
  }

  endDrag() {
    if (!this.isDragging) return;
    this.isDragging = false;
    const maxOffset = this.getSliderMaxOffset();
    const threshold = Math.floor(maxOffset * 0.9);
    if (this.currentSliderX >= threshold) {
      this.isActivated = true;
      this.slideLocked = true;
      this.swipeToBuyBtn = "";
      this.btnClass = "loading-dots";
      this.proceedToPay(true);
      document.querySelector(".slider-container")?.classList.add("activated");
      this.currentSliderX = maxOffset;
      this.slide_btn?.nativeElement?.style?.setProperty("transform", `translateX(${maxOffset}px)`);
    } else {
      this.currentSliderX = 5;
      this.slide_btn?.nativeElement?.style?.setProperty("transform", "translateX(5px)"); // Reset position
    }
  }
  // slide btn end

  // New helper methods to support parallel loading

  private initializeRedirectUrl(): void {
    this.redirectlink = this.sanitizer.bypassSecurityTrustResourceUrl(environment.checkOutUrl);
  }

  private async setupNetworkMonitoring(): Promise<void> {
    this.networkListener = await Network.addListener("networkStatusChange", (e) => {
      try {
        if (e.connected) {
          this.isOnline = true;
        } else {
          this.isOnline = false;
        }
      } catch (error) {
        this.authService.errorHandlerLogs("Network monitoring error", error);
      }
    });
  }

  private handleRedirectionFlow(): void {
    const currentRoute = localStorage.getItem("currentRoute");
    const isPaymentDone = localStorage.getItem("isPaymentDone");
    if (currentRoute && isPaymentDone === "true") {
      this.addingCard = true;
      this.isPaymentDone = false;
      this.addNewCardInProgress = true;
    } else {
      const currentUrl = this.router.url;
      localStorage.removeItem("d");
      localStorage.setItem("currentRoute", currentUrl);
    }
  }

  private processTranslationData(noThanks: Data): void {
    // Process popup text translation code...
    const popupTexts = noThanks["no-thanks-popup"];
    if (popupTexts) {
      this.sureText = popupTexts["sure_4375"];
      this.buttonText = popupTexts["back_4375"];

      // Load additional translation-dependent data asynchronously.
      // Fix for LOTTOSOCIAL-PWA-1NBK: the original nested subscriptions to
      // userDetails$ and getCurrencyList$ (both BehaviorSubjects) had no take(1),
      // causing unbounded subscription growth and re-entrant emissions that
      // exhausted the JS call stack.
      //
      // The entire chain is a single pipeline (no nested subscribe). forkJoin
      // waits for both sources to emit once and complete:
      //   - userDetails$ is taken as-is with take(1); null/undefined is fine
      //     because the subscriber's fallback chain (safeLocalStorage →
      //     user.preferred_currency → CommonVariable defaults) handles it.
      //   - getCurrencyList$ may emit an empty placeholder before currency data
      //     loads, so we wait for a non-empty details array before taking(1).
      //     A 5 s timeout silently completes the pipeline (via EMPTY) when the
      //     list never arrives, leaving {{price}} unreplaced rather than hanging.
      // takeUntil tears the subscription down on component destroy; catchError
      // logs and swallows any upstream error.
      this.AuthPartialRegService.partial_Reg("4375", "", "")
        .pipe(
          take(1),
          switchMap((s) =>
            forkJoin([
              this.authService.userDetails$.pipe(take(1)),
              this.authService.getCurrencyList$.pipe(
                filter((res: Data) => Array.isArray(res?.details) && res.details.length > 0),
                take(1),
              ),
            ]).pipe(
              map(([user, res]: [Data, Data]) => ({ s, user, res })),
              timeout({ each: 5000, with: () => EMPTY }),
            )
          ),
          takeUntil(this.destroy$),
          catchError((err) => {
            this.authService.errorHandlerLogs('[processTranslationData] Error resolving currency for popup text:', err);
            return EMPTY;
          }),
        )
        .subscribe(({ s, user, res }) => {
          this.preferredCurrency = this.safeLocalStorage.getItem("user_currency") ?? user?.preferred_currency ?? CommonVariable.preferredCurrency;
          const CurrencyDetails = res?.details?.find((x: Data) => x?.currency_code === this.preferredCurrency);
          this.currencySymbol = CurrencyDetails?.currency_symbol ?? CommonVariable.defaultCurrencySymbol;

          const finalPrice = s?.prosubDetail?.int_price?.[this.preferredCurrency];
          // Use != null so a legitimate price of 0 still replaces the placeholder.
          if (this.sureText && finalPrice != null) {
            this.sureText = this.sureText?.replace("{{price}}", this.currencySymbol + finalPrice);
          }
          if (this.buttonText && finalPrice != null) {
            this.buttonText = this.buttonText?.replace("{{price}}", this.currencySymbol + finalPrice);
          }
        });
    }
  }

  private loadNonEssentialData(): void {
    // Load data that isn't needed for initial UI render
    if (this.paymentPageData?.includes(this.jackpotNextDrawDateKey)) {
      this.fetchJackpotData();
    }
  }

  // This function is used to change the check card
  // It takes in the stored cards and the index
  // It then maps through the stored cards and changes the check card to true
  // and the other cards to false
  changeCheckCard(storedCards, index) {
    // Special case for single card
    if (storedCards.length === 1) {
      // Remove unnecessary setTimeout - it causes UI delays
      storedCards[index].isChecked = true;
      return;
    }

    // Update checked state in a single pass
    storedCards.forEach((card, cIndex) => {
      card.isChecked = index === cIndex;
    });

  }

  async proceedToPay(one_click_pay = false) {
    if (this.fourCJourneyState && !this.fourCJourneyState.canSubmitPayment) {
      this.showPaymentUnavailable(
        this.fourCJourneyState.blockedReason ||
          "Payment is not available for this journey state."
      );
      return;
    }

    // Toast only on Pay Now when Firebase capping_status is true (store offer-capping path)
    if (this.purchaseDetail) {
      const isFirebaseOfferCapped = await this.storeService.validateOfferCappingBeforePurchase(
        this.purchaseDetail,
        "free_reg_4c_pay"
      );
      if (isFirebaseOfferCapped) {
        return;
      }
    }

    // Backup: check4cFlow reported cappingStatus / capping_status true
    if (this.isOfferCapped) {
      const defaultMsg = {
        message: {
          line_1: "D-1165-This offer is no longer available because you've reached the purchase limit.",
          line_2: "",
        },
        style: {
          icon: "tick circle error.svg",
          type: "Error",
        },
      };
      try {
        const translatedMsg = await this.authService.getConstantsMsg("1165");
        this.authService.showToastMessage(translatedMsg, defaultMsg);
      } catch {
        this.authService.showToastMessage({}, defaultMsg);
      }
      return;
    }

    if (!this.purchaseDetail?.offers) {
      this.showPaymentUnavailable("Payment details are still loading. Please try again.");
      return;
    }

    const selectedStoredCard = this.getCheckCardDetailId();
    const resolvedStoredCardId = this.resolveStoredCardId(selectedStoredCard);

    if (!resolvedStoredCardId) {
      this.resetSavedCardCtas();
      this.startNewCardFlow();
      return;
    }

    const normalizedSelectedStoredCard = selectedStoredCard?.encrypt_card_id
      ? selectedStoredCard
      : { ...selectedStoredCard, encrypt_card_id: resolvedStoredCardId };

    if (!this.canUseStoredCard(normalizedSelectedStoredCard)) {
      this.showPaymentUnavailable("Payment is not ready yet. Please try again.");
      return;
    }

    this.isDirectPayNowInProgress = !one_click_pay;
    this.startSpinner();

    this.paymentFlowService.proceedToPay({
      purchaseDetail: this.purchaseDetail,
      selectedStoredCard: normalizedSelectedStoredCard,
      one_click_pay,
      processcustomer_offer: this.processcustomer_offer,
      altprosubDetails: this.altprosubDetails,
    }).pipe(
      finalize(() => {
        this.isDirectPayNowInProgress = false;
        this.stopSpinner();
        this.loadingService.dismiss();
      })
    ).subscribe({
      next: ({
        process_card_payment_response,
        encrypted_customer_purchase_id
      }) =>
        this.handle_pay_response(
          process_card_payment_response,
          encrypted_customer_purchase_id,
          one_click_pay
        ),
      error: (error) => {
        this.paymentFlowService.handle_payment_error(error);
        // Swipe-only recovery: hide swipe and open add-card on the same 4C page.
        if (one_click_pay) {
          this.fallbackFromFailedSwipeToAddCard();
        }
      }
    });
  }

  pollPaymentStatus(
    encryptedCustomerPurchaseId: string,
    one_click_pay: boolean
  ) {
    // Guard: an absent ID means there is nothing to poll — bail out early.
    if (!encryptedCustomerPurchaseId) {
      return;
    }

    if (one_click_pay) {
      this.mixPanelService.trackOneClickPayments("4C Page");
    }

    let successHandled = false;
    let pollFailureData: Data | null = null;
    this.paymentFlowService.pollPaymentStatus(encryptedCustomerPurchaseId)
      .subscribe({
        next: (res) => {
          try {
            if (res?.success) {
              if (one_click_pay) {
                // One-click UI path historically skipped GTM_CJ_conversion — fire it here.
                this.pushPaymentSuccessGtm(
                  res?.data,
                  encryptedCustomerPurchaseId
                );
                const encrypt_syndicate_id = res?.data?.api_response?.response?.encrypt_syndicate_id;
                this.handlePaymentSuccess(encrypt_syndicate_id);
              } else {
                this.completePaymentSuccessFromApiResponse(
                  res?.data,
                  encryptedCustomerPurchaseId
                );
              }
              // Only mark success after handlers return without throwing, so
              // `complete` can still run failure/fallback recovery on sync errors.
              successHandled = true;
              return;
            }
            if (res?.data) {
              pollFailureData = res.data;
            }
          } catch (err) {
            // Keep successHandled false so `complete` runs shared failure/fallback UI.
            this.paymentFlowService.handle_payment_error(err);
          }
        },
        error: (error) => {
          // Observable errors skip `complete`, so run the same UI recovery here.
          this.paymentFlowService.handle_payment_error(error);
          this.handlePollPaymentStatusFailure(one_click_pay, null);
        },
        complete: () => {
          if (!successHandled) {
            this.handlePollPaymentStatusFailure(one_click_pay, pollFailureData);
          }
        },
      });
  }

  /**
   * Shared poll failure UI recovery for both `error` and unsuccessful `complete`.
   * One-click: stay on 4C and open add-card. Standard pay: reset swipe state.
   */
  private handlePollPaymentStatusFailure(
    one_click_pay: boolean,
    pollFailureData: Data | null
  ): void {
    if (one_click_pay) {
      this.fallbackFromFailedSwipeToAddCard();
    } else {
      this.resetSlideToBuyState();
    }
    this.showFourCAlertFromMappedCheckoutStatus(pollFailureData);
  }

  handlePaymentSuccess(encrypt_syndicate_id) {
    timer(5000)
      .pipe(
        tap(() => {
          document.querySelector(".pay-success")?.classList.add("activated");
        }),
        delay(1500),
        concatMap(() => {
          const constantsMsgPromise = this.authService.getConstantsMsg?.("1158");
          const constantsMsg$ =
            constantsMsgPromise && typeof (constantsMsgPromise as Promise<Data>).then === "function"
              ? from(constantsMsgPromise)
              : of(null);
          return constantsMsg$.pipe(
            tap((translatedMsg) => {
              const defaultMsg = {
                message: {
                  line_1: "Congrats, you are in!",
                  line_2: "",
                },
                style: {
                  icon: "tick circle error.svg",
                  type: "Success",
                },
              };
              this.authService.showToastMessage(translatedMsg, defaultMsg);
            }),
            catchError((error) => {
              this.authService.errorHandlerLogs("Failed to load toast message 1158", error);
              return of(null);
            })
          );
        }),
        delay(2000),
        tap(() => {
          document.querySelector(".pay-success")?.classList.remove("activated");
          if (this.slide_btn?.nativeElement) {
            this.slide_btn.nativeElement.style.transform = `translateX(5px)`;
          }
          this.currentSliderX = 5;
          this.swipeToBuyBtn = "checkout_try_again.swipe_to_buy";
          this.btnClass = "";
          this.isActivated = false;
          this.startX = 0;
          this.router.navigate(["mainTabs/tabs/syndicate"], { state: { encrypt_syndicate_id: encrypt_syndicate_id } });
          this.cashPurchaseService.toastTrigger$.next(true);
        })
      )
      .subscribe();
  }

  changeSlideBtnStatus() {
    timer(3000)
      .pipe(
        tap(() => {
          this.slideToBuyBtnStatus = false;
          return;
        })
      )
      .subscribe();
  }

  public logCustomerPurchase(data: Data) {
    this.updateLogToLocal(data);
  }
  // This function starts the spinner animation, and sets the progress bar to 0.
  // It also subscribes to an interval observable, and updates the progress bar
  // every 300 milliseconds.
  startSpinner() {
    this.spinnerAnimation = true;
    this.progressBar = 0;
    this.timer$ = interval(300);
    this.sub = this.timer$.subscribe(
      (sec) => {
        this.progressBar = 0 + sec;
      },
      (err) => {
        return err;
      }
    );
  }


  private ensureCheckoutDetailsReady(maxWaitMs = 5000): Promise<boolean> {
    const details$ = this.paymentDataService.checkoutDetails$;
    const isResolved = (value: Data): boolean =>
      !!value && typeof value === "object" && Object.keys(value).length > 0;
    const hasConfiguredPType = (): boolean => {
      const configuredPType = this.purchaseDetail?.p_type ? String(this.purchaseDetail.p_type) : "";
      return !!configuredPType;
    };

    if (isResolved(details$.value) || hasConfiguredPType()) {
      return Promise.resolve(true);
    }

    // Make sure the fetch has been kicked off (idempotent enough for a refetch).
    this.paymentDataService.getCheckoutDetails();

    return new Promise<boolean>((resolve) => {
      details$
        .pipe(
          filter((value) => isResolved(value)),   // wait until a real value arrives
          take(1),                                 // auto-complete after first match
          timeout(maxWaitMs),                      // throw after maxWaitMs if nothing
          catchError(() => of(null)),
        )
        .subscribe((value) => {
          if (isResolved(value)) {
            resolve(true);
            return;
          }

          resolve(hasConfiguredPType());
        });
    });
  }

  // This function is for add new card functionalities.
  async addNewCard() {
    if (this.paymentHold) {
      // startNewCardFlow may have latched addingCard flags; restore a recoverable CTA.
      this.addNewCardInProgress = false;
      this.addingCard = false;
      this.showAddNewCard = true;
      this.changeDetRef?.detectChanges();
      return;
    }

    this.timerOn = true;
    localStorage.setItem("currentRoute", this.router.url);

    // Wait for the checkout.com gateway config before selecting the payment gateway,
    // otherwise a cold-load race routes the user to the wrong (Paymill) flow.
    const isCheckoutReady = await this.ensureCheckoutDetailsReady();
    if (!isCheckoutReady) {
      // HATDEV-99039: do not leave Payable footer with no Pay / Add Card CTA.
      this.addNewCardInProgress = false;
      this.addingCard = false;
      this.showAddNewCard = true;
      this.changeDetRef?.detectChanges();
      return;
    }

    try {
      const result = await this.paymilPaymentService.addNewCard(this.purchaseDetail, window);

      if (result.status === 'new-card') {
        this.selectedCard = result.cardDetails;
        this.currentNdc = result.currentNdc;
        this.addNewCardInProgress = true;
        this.isCheckoutCom = false;
        this.pathString = result.pathString;
        this.addingCard = true;
        this.insertCustomerPurchaseRes = result.insertCustomerPurchaseRes;
        this.updateAddonDataForPaymilPayment(this.purchaseDetail.addons);

        const time = localStorage.getItem("minutes");
        this.basePaymentService.start(
          CommonVariable.paymentTimer - parseInt(time),
          this.timerspan,
          () => {
            this.timeOut = true;
            this.addNewCardInProgress = false;
            this.showAddNewCard = true;
            this.count = 0;
            this.isPaymentDone = false;
          }
        );
      } else {
        this.getPaymentFormLoaded();
      }
      return;
    } catch (error) {
      this.addNewCardInProgress = false;
      this.addingCard = false;
      this.showAddNewCard = true;
      this.changeDetRef?.detectChanges();
      return error;
    }
  }

  getPaymentFormLoaded() {
    localStorage.removeItem("minutes");
    localStorage.removeItem("c_id");
    localStorage.removeItem("initialProsub");

    const cardDetails = this.paymentCardService?.setSelectedCard(this.purchaseDetail);
    if (cardDetails) {
      this.selectedCard = cardDetails;
    }
    this.purchaseDetail["p_type"] = this.selectedCard;
    this.paymentService.selected_p_type = this.selectedCard;
    this.addNewCardInProgress = true;
    this.pageScroller();
    if (window.navigator.onLine) {
      this.logCustomerPurchase({
        co_request: {
          amount: parseFloat(this.purchaseDetail.prize)?.toFixed(2),
          currency: this.purchaseDetail?.offers?.currency ? this.purchaseDetail?.offers?.currency : "GBP",
        },
        co_startDate: new Date(),
      });

      if (this.selectedCard === "10" || this.selectedCard === "15" || this.selectedCard === "22") {
        this.paymilPaymentService.getCheckoutId(this.purchaseDetail, {
          userId: this.userId,
          tp1: this.TP1,
          tp2: this.Tp2,
          tp3: this.TP3,
          tId: this.T_ID,
          currency: this.preferredCurrency,
          payReason: this.paymentReason
        }).subscribe({
          next: (res: Data) => {
            if (!res || res.error || !res.id) {
              this.handleCheckoutIdFailure();
              return;
            }

            this.handleCheckoutIdSuccess(res);
          },
          error: (err) => { this.handleCheckoutIdError(err) }
        });
      } else if (this.selectedCard === "21") {
        this.handleFormSelectedCard()
      } else if (this.selectedCard === "20") {
        this.modalCtrl.dismiss().then(() => {
        });
        const st_req = {
          secure_trading_request: {
            currencyiso3a: this.purchaseDetail?.offers?.currency ? this.purchaseDetail?.offers?.currency : "GBP",
            baseamount: parseInt(this.purchaseDetail.prize)?.toFixed(2),
            orderreference: null,
          },
        };
        this.updateLogToLocal({ check_3dsecure: "no", isSecureTrading: true, ...st_req });
      } else {
        this.showPayFailureConstantsOrToast("1086", "Something went wrong on select card");
      }
    }
  }

  // this function is used to check payment flow on payment page load
  load(e) {
    this.count++;
    if (this.count > 1) {
      if (!this.isPaymentDone) {
        this.GTMSegment.fourxCtaClicked();
      }
      // updating 'isPaymentDone' to true, following same logic as used in AddCardComponent component
      // this needs to be done to show 3DS notice on payment iframe
      this.isPaymentDone = true;
      //this.loadingService.present();
    }
    this.afterNewCardPaymentDoneUpdated();
  }

  afterNewCardPaymentDoneUpdated() {
    if (!this.paymentReceivedFromCP) {
      this.paymentReceivedFromCP = true;

      this.paymilPaymentService.afterPaymentDone(this.currentNdc)
        .pipe(takeUntil(this.unsubscribeStatusFromPayment$)).subscribe({
          next: (purchaseDoc) => this.processAfterPayment(purchaseDoc),
          error: (err) => { }
        })
    }
  }

  resetPaymentSubscriptions(): void {
    this.unsubscribeStatusFromCP$?.next();
    this.unsubscribeStatusFromCP$?.complete();
    this.unsubscribeStatusFromPayment$?.next();
    this.unsubscribeStatusFromPayment$?.complete();
  }

  afterNewCardPaymentDone(): void {
    if (this.paymentReceived || !localStorage.getItem('d')) {
      return;
    }

    this.paymentReceived = true;
    this.paymentReceivedFromCP = true;
    this.loadingService.dismiss();

    const urlData = JSON.parse(localStorage.getItem('d'));
    localStorage.removeItem('d');

    setTimeout(() => {
      this.paymentFlowService
        .checkNewCardPaymentStatus(
          urlData?.id,
          this.paymentMode,
          this.isFourCCheckoutRoute()
            ? (line1) => {
                void this.showFourCAlertByConstantsCode(
                  "1026",
                  line1 || "Something went wrong!",
                  "error"
                );
              }
            : undefined
        )
        .pipe(takeUntil(this.unsubscribeStatusFromPayment$))
        .subscribe({
          next: (result) => {
            if (result.type === 'success') {
              this.onPaymentStatusReceived(
                result.payload,
                false
              );
              this.payment_status = result.payment_status;
              this.paymentHold = false;
            } else this.resetPaymentState();
          },
          error: () => this.resetPaymentState()
        });
    }, 1000);
  }

  public resetPaymentState(): void {
    this.addingCard = false;
    this.addNewCardInProgress = false;
    this.showAddNewCard = true;
    this.proceed = true;
    this.isPaymentDone = false;
    this.remaining = 0;
    this.count = 0;
    this.paymentReceived = false;
    this.paymentReceivedFromCP = false;
    this.paymentHold = false;
    this.resetPaymentSubscriptions();
    this.paymentService.resetPostPaymentTicketState();
    this.syndicateId = null;
    this.postPaymentTicketFlowStarted = false;
  }

  private onPaymentStatusReceived(
    payment_status,
    paymentStatusFromCP: boolean
  ) {
    this.paymentFlowService.handlePaymentStatusReceived(payment_status, paymentStatusFromCP, this);
  }


  public manualLoginPayment(token: string, payment_status: Data) {
    this.tokenValidaterSub = this.paymilPaymentService.manualLoginPayment(token).subscribe({
      next: (user) => {
        if (this.checkoutPaymentSuccess) {
          this.checkoutPaymentDoneFlow();
          return;
        }

        if (user) {
          this.handleSuccessPayment(payment_status);
        }
      },
      error: (err) => {
        if (this.checkoutPaymentSuccess) {
          this.checkoutPaymentDoneFlow();
          return err;
        }
        this.showPayFailureConstantsOrToast("1086", "Something went wrong on select card");
        return err;
      }
    })
  }

  // This function is for get syndicate id from payment response
  getPaymentSyndicateId(payment_status: Data) {
    const customerPurchaseJSON = this.paymentService.insertCustomerPurchaseRequestJson(
      { ...this.purchaseDetail, ...this.getCheckCardDetailId() },
      "insert_customer_purchase_4c_payment"
    );

    this.paymentFlowService.getPaymentSyndicateId(
      this.purchaseDetail,
      payment_status,
      customerPurchaseJSON,
      this
    ).subscribe({
      next: () => {
        localStorage.removeItem("purchaseDetailData");
      },
      error: () => {
        this.paymentService?.trackCustomerPurchase(payment_status?.ndc);
      }
    });
  }

  // This function returns the card details of the card that is checked. If no cards are checked then it returns undefined.
  getCheckCardDetailId() {
    if (!this.storedCards) {
      return;
    }
    return this.storedCards?.find((x) => x.isChecked);
  }

  /** Resolves stored-card id from known response aliases used across legacy payment payloads. */
  private resolveStoredCardId(card: any): string {
    return (
      card?.encrypt_card_id ||
      card?.pay_stored_detail_id ||
      card?.customer_payment_stored_detail_id ||
      card?.customer_Payment_stored_detail_ID ||
      ""
    );
  }

  /** Returns true when the given stored card is valid and the page is ready for payment. */
  canUseStoredCard(card = this.getCheckCardDetailId()): boolean {
    const journeyAllowsPayment =
      !this.fourCJourneyState || this.fourCJourneyState.canSubmitPayment;
    return !!this.resolveStoredCardId(card) &&
      !this.spinnerAnimation &&
      this.isOnline &&
      this.isCappingCheckDone &&
      journeyAllowsPayment;
  }

  /** Returns true when slide-to-buy CTA should be rendered (flags enabled AND a valid card exists). */
  showSlideToBuy(): boolean {
    if (this.suppressSwipeToBuyAfterFailure) {
      return false;
    }

    const isSlideEnabledByConfig = this.slideToBuyBtnStatus && this.proSubSlideToBuyStatus;
    if (!isSlideEnabledByConfig) {
      return false;
    }

    // Keep slider rendered while processing/locked to avoid brief Pay button flicker.
    return this.canUseStoredCard() || this.slideLocked || this.isActivated || this.spinnerAnimation;
  }

  /** Returns true when the regular saved-card Pay button should be rendered. */
  showStoredCardPay(): boolean {
    return !this.showSlideToBuy() && (this.canUseStoredCard() || this.isDirectPayNowInProgress);
  }

  /** Returns true when no valid stored card exists and the card-entry flow should be shown. */
  showNewCardFlow(): boolean {
    return !this.resolveStoredCardId(this.getCheckCardDetailId());
  }

  private showPaymentUnavailable(message: string): void {
    this.authService.errorHandlerLogs('[proceedToPay] ' + message);
    this.showPayFailureRawOrToast(message);
  }

  public showPayFailureRawOrToast(line1: string): void {
    const message = line1 || "Something went wrong!";
    if (this.isFourCCheckoutRoute()) {
      void this.showFourCAlertByConstantsCode("1026", message, "error");
    } else {
      this.basePaymentService.showToast("", message, "Error");
    }
  }

  private showPayFailureConstantsOrToast(code: string, fallbackLine: string): void {
    const line1 = fallbackLine || "Something went wrong!";
    if (this.isFourCCheckoutRoute()) {
      void this.showFourCAlertByConstantsCode(code, line1, "error");
    } else {
      this.basePaymentService.showToast(code, line1, "Error");
    }
  }

  private resetSavedCardCtas(): void {
    this.slideToBuyBtnStatus = false;
    this.showAddNewCard = false;
  }

  private handleNoStoredCard(): void {
    this.storedCards = [];
    this.showAddNewCard = false;
    this.resetSavedCardCtas();
    if (this.addNewCardInProgress) {
      return;
    }
    this.startNewCardFlow();
  }

  private maybeTriggerNoCardFallbackAfterCapping(): void {
    if (!this.isCappingCheckDone) {
      return;
    }

    if (Array.isArray(this.storedCards) && this.storedCards.length === 0) {
      this.handleNoStoredCard();
    }
  }

  private startNewCardFlow(): void {
    this.addingCard = true;
    this.addNewCardInProgress = true;
    this.addNewCard();
  }

  private resetSlideToBuyState(): void {
    this.btnClass = "";
    this.isActivated = false;
    this.slideLocked = false;
    this.currentSliderX = 5;
    this.startX = 0;
    if (this.slide_btn?.nativeElement) {
      this.slide_btn.nativeElement.style.transform = `translateX(5px)`;
    } 
    this.swipeToBuyBtn = "checkout_try_again.swipe_to_buy";
    document.querySelector(".slider-container")?.classList.remove("activated");
  }

  /**
   * After a failed stored-card Swipe to Buy on 4C:
   * - reset and permanently suppress swipe for this page session
   * - open the standard add-card / click-to-buy UI on the same 4C page
   * - do not navigate to store checkout-try-again (preserves 4C basket/rules/state)
   */
  fallbackFromFailedSwipeToAddCard(): void {
    this.suppressSwipeToBuyAfterFailure = true;
    this.slideToBuyBtnStatus = false;
    this.resetSlideToBuyState();
    this.proceed = true;
    this.isDirectPayNowInProgress = false;
    this.showAddNewCard = true;
    this.stopSpinner();

    // Keep purchaseDetail (base offer, addons, totals) and query params intact.
    if (this.addNewCardInProgress || this.addingCard) {
      this.changeDetRef?.detectChanges();
      return;
    }
    this.startNewCardFlow();
    this.changeDetRef?.detectChanges();
  }

  // This function is used to stop the spinner animation after the progress bar reaches 100%.
  // It is also used to change the proceed button to active.
  // The proceed button is activated by the boolean value of proceed.
  stopSpinner() {
    this.progressBar = 100;
    this.sub?.unsubscribe();
    this.spinnerAnimation = false;
    this.proceed = true;
    this.detectChanges();
  }

  /** Narrow wrapper so services can trigger change detection without holding a public ChangeDetectorRef. */
  public detectChanges(): void {
    if (!this.isDestroyed) {
      this.changeDetRef?.detectChanges();
    }
  }

  // This function opens the No Thanks popup
  openNoThanks() {
    const modal = this.matDialog.open(NoThanksPopupComponent, {
      height: "40%",
      width: "80%",
      data: {
        sureText: this.sureText || "",
        buttonText: this.buttonText || "",
      },
    });
    modal.afterClosed().subscribe((resp: boolean) => {
      if (resp) {
        // resetting iframe states to default
        this.timeOut = true;
        this.addingCard = false;
        this.addNewCardInProgress = false;
        this.showAddNewCard = true;
        this.count = 0;
        this.isPaymentDone = false;
      }
    });
  }

  private completePaymentSuccessFromApiResponse(
    process_card_payment_resp: Data,
    encryptedCustomerPurchaseId?: string
  ): void {
    const response =
      process_card_payment_resp?.response ??
      process_card_payment_resp?.api_response?.response ??
      process_card_payment_resp;

    const encryptSyndicateId =
      response?.syndicate_id ?? response?.encrypt_syndicate_id ?? null;
    const encryptCpId =
      encryptedCustomerPurchaseId ||
      response?.encrypted_customer_purchase_id ||
      this.paymentService.salesJourneyCustomerPurchaseId$.value ||
      null;
    const resolvedPurchaseId =
      this.customer_purchase_id ||
      response?.customer_purchase_id ||
      encryptCpId ||
      null;

    if (resolvedPurchaseId) {
      this.customer_purchase_id = resolvedPurchaseId;
    }

    this.GTMSegment.fourxCtaClicked();
    this.paymentService?.setSyndicatePending();
    this.progressBar = 100;
    this.isPaymentDone = true;
    this.proceed = false;
    this.paymentService.resetPostPaymentTicketState();
    if (encryptCpId) {
      this.paymentService.salesJourneyCustomerPurchaseId$.next(encryptCpId);
    }
    if (encryptSyndicateId) {
      this.paymentService.salesJournyPaymentDetails$.next(encryptSyndicateId);
    }
    this.responseObject = { ...this.purchaseDetail, ...response };
    this.pushPaymentSuccessGtm(process_card_payment_resp, encryptedCustomerPurchaseId);
    setTimeout(() => {
      this.callInt2();
    }, 500);
  }

  /** Pushes payment_success / CJ conversion for all 4C success entry points. */
  private pushPaymentSuccessGtm(
    process_card_payment_resp?: Data,
    encryptedCustomerPurchaseId?: string
  ): void {
    const response =
      process_card_payment_resp?.response ??
      process_card_payment_resp?.api_response?.response ??
      process_card_payment_resp;
    const purchaseFromCheckout =
      response?.payment_request?.customer_purchase?.customer_purchase_id ||
      response?.payment_request?.customer_purchase?.encrypted_customer_purchase_id;
    // Prefer plain customer_purchase_id for AppLovin transaction_id.
    const resolvedPurchaseId =
      this.customer_purchase_id ||
      purchaseFromCheckout ||
      response?.customer_purchase_id ||
      encryptedCustomerPurchaseId ||
      response?.encrypted_customer_purchase_id ||
      this.paymentService.salesJourneyCustomerPurchaseId$.value ||
      null;

    if (resolvedPurchaseId) {
      this.customer_purchase_id = resolvedPurchaseId;
    }

    const purchaseContext = {
      purchaseDetail: this.purchaseDetail,
      altprosubDetails: this.altprosubDetails,
      preferredCurrency: this.preferredCurrency || "GBP",
      paymentMethod: "CheckOut",
      brand: "App",
    };
    const amount =
      this.altprosubDetails?.price ??
      this.purchaseDetail?.prize ??
      this.purchaseDetail?.offers?.price ??
      this.purchaseDetail?.offers?.int_price?.[this.preferredCurrency] ??
      this.purchaseDetail?.offers?.int_price?.GBP;
    const offerId =
      this.altprosubDetails?.offerid ??
      this.altprosubDetails?.offer_id ??
      this.purchaseDetail?.offer_id ??
      this.purchaseDetail?.offers?.offerid ??
      this.purchaseDetail?.offers?.offer_id ??
      this.offer_id;
    const prosubId =
      this.altprosubDetails?.prosub_id ??
      this.purchaseDetail?.prosub_id ??
      this.Prosub_id ??
      localStorage.getItem("prosub_id");

    this.GTMSegment.userProduct$.next(this.GTMSegment.userProduct$.value);
    this.GTMService.GTM_CJ_conversion(
      amount,
      this.purchaseDetail?.offers?.currency
        ? this.purchaseDetail?.offers?.currency
        : this.preferredCurrency || "GBP",
      offerId,
      this.GTMService?.userIsNew ? "new" : "return",
      CommonVariable.countryCode,
      this.purchaseDetail?.p_type ? this.purchaseDetail?.p_type : "10",
      prosubId,
      this.customer_purchase_id || "",
      purchaseContext
    );
  }

  // This function is for call interstitial 2 functionalities and redirect to specific page
  async callInt2() {
    return this.paymentNavigationService.callInt2(this.buildNavCtx());
  }


 freeReg4cNavigation(path: string[]) {
    return this.paymentNavigationService.freeReg4cNavigation(path, this.buildNavCtx());
  }

  // This function is used to fetch syndicate
  fetchSyndicate() {
    return this.paymentNavigationService.fetchSyndicate(this.syndicateId);
  }

  private buildNavCtx() {
    return {
      Prosub_id: this.Prosub_id, TP1: this.TP1, Tp2: this.Tp2, TP3: this.TP3, T_ID: this.T_ID,
      upsellID: this.upsellID, timerOn: this.timerOn, spinnerAnimation: this.spinnerAnimation,
      isPaymentDone: this.isPaymentDone, addingCard: this.addingCard, addNewCardInProgress: this.addNewCardInProgress,
      getCheckCardDetailId: () => this.getCheckCardDetailId(),
      onStateChange: (patch: Data) => Object.assign(this, patch),
      _syndicateId: this.syndicateId,
    };
  }

  // This function is handling success payment and display appropriate snack bar message
  public handleSuccessPayment(payment_status: Data) {
    return this.paymentFlowService.handleSuccessPayment(payment_status, this);
  }

 private fetchJackpotData(): void {
    this.jackpotSubscription?.unsubscribe();
    this.jackpotSubscription = this.jackpotDisplayHelper
      .getJackpotText(this.paymentPageData)
      .subscribe({
        next: (resolved) => { this.paymentPageData = resolved; },
        error: (err) => { this.authService.errorHandlerLogs('[fetchJackpotData] error:', err); }
      });
  }

  ionViewWillLeave(): void {
    this.timerOn = false;
    this.jackpotSubscription?.unsubscribe();
  }

  afterNewCardPaymentDoneCheckout() {
   this.paymilPaymentService.afterNewCardPaymentDoneCheckout(this);
  }

  public onValidationChanged(event: Data): void {
    const hasError = !event.isValid && !event.isEmpty;

    if (hasError) {
      this.errorStack.push(event.element);
    } else {
      this.errorStack = this.errorStack.filter((element) => element !== event.element);
    }

    this.errorMessage = this.errorStack.length ? this.getErrorMessage(this.errorStack[this.errorStack.length - 1]) : "";
  }

  public getErrorMessage(element: string): string {
    const errors: { [key: string]: string } = {
      "card-number": "Please enter a valid card number",
      "expiry-date": "Please enter a valid expiry date",
      cvv: "Please enter a valid CVV code",
    };

    return errors[element] || "An error occurred.";
  }

  isCheckoutLoadingMessage(message: string): boolean {
    return (message || "").trim().toLowerCase() === "loading secure card form...";
  }

  public async onCardTokenized(event: Data): Promise<void> {
    try {
      await this.checkoutFlowService.onCardTokenized(this.asCheckoutFlowHost(), event);
    } catch (error) {
      this.handleCheckoutFlowError(error as Data, true);
    }
  }

  /**
   * Localized CheckoutComFlowHost cast — PaymentPage private members prevent a direct
   * `implements CheckoutComFlowHost`; keep the cast here rather than scattering `as any`.
   */
  private asCheckoutFlowHost(): CheckoutComFlowHost {
    return this as unknown as CheckoutComFlowHost;
  }

  private async ensureCheckoutSessionValid(): Promise<boolean> {
    try {
      const auth = getAuth();
      const user = auth?.currentUser;
      if (!user) {
        return false;
      }
      // forceRefresh = true guarantees a valid token even when the SDK's background
      // refresh was throttled while the tab was idle/asleep (notably on Edge).
      await user.getIdToken(true);
      return true;
    } catch (error) {
      this.authService.errorHandlerLogs(
        "Checkout session refresh failed before tokenization:",
        error
      );
      return false;
    }
  }

  private handleCheckoutSessionExpired(error?: Data): void {
    if (this.checkoutSessionExpiredHandled) return;
    this.checkoutSessionExpiredHandled = true;

    this.authService.errorHandlerLogs(
      "Checkout session expired/invalid after inactivity; prompting retry.",
      error
    );

    // Same recovery used for checkout payment failures: dismisses the loader,
    // clears iframe recovery timers, resets payment subscriptions and re-shows the
    // add-card UI without clearing purchaseDetail (cart/selection is preserved).
    this.resetCheckoutcomStates();
    if (this.storedCards && this.storedCards?.length === 0) {
      this.addNewCard();
    }

    this.showCheckoutSessionExpiredMessage();
  }

  /** Clear, route-appropriate "session expired" feedback (no silent failures). */
  private showCheckoutSessionExpiredMessage(): void {
    const line1 =
      "Your session timed out due to inactivity. Please re-enter your card details and try again.";

    if (this.isFourCCheckoutRoute()) {
      void this.showFourCAlertByConstantsCode("1026", line1, "error");
      return;
    }

    const defaultMsg = {
      message: { line_1: line1, line_2: "" },
      style: {
        icon: "tick circle error.svg",
        type: "Error",
        duration_ms: 6000,
      },
    };
    this.authService.showToastMessage({}, defaultMsg);
  }

  public onSubmit(event: Event): void {
    event.preventDefault();
    if (this.fourCJourneyState && !this.fourCJourneyState.canSubmitPayment) {
      this.errorMessage =
        this.fourCJourneyState.blockedReason ||
        "Payment is not available for this journey state.";
      this.showPaymentUnavailable(this.errorMessage);
      return;
    }
    // Flow owns card entry; do not call legacy Frames.submitCard (Frames init removed).
    try {
      if (!this.checkoutFlowService.submitPayment()) {
        this.errorMessage = "Payment form is still loading. Please try again.";
        return;
      }
    } catch (error) {
      this.handleCheckoutFlowError(error as Data, true);
    }
  }

  private loadCheckoutComFlow(data: Data): void {
    this.checkoutFlowService.loadCheckoutComFlow(this.asCheckoutFlowHost(), data);
  }

  private clearCheckoutIframeRecovery(): void {
    this.checkoutFlowService.clearCheckoutIframeRecovery(this.asCheckoutFlowHost());
  }

  private cancelCheckoutFramesInit(): void {
    this.checkoutFramesInitCancelled = true;            // NEW – stops poll loop
    if (this.checkoutFramesInitFrame !== null) {
      cancelAnimationFrame(this.checkoutFramesInitFrame);
      this.checkoutFramesInitFrame = null;
    }
  }


  /**
   * Mounts Checkout Flow UI using keys already loaded by loadCheckoutComFlow.
   * Intentionally does not re-fetch getCheckoutApiDetails (avoids double-fetch / mount-timing risk).
   * Preserves LIVE mount-cancel handling and Flow ready/recovery behaviour in CheckoutFlowService.
   */
  private initializeCheckoutFlowIFrames(): void {
    const host = this.asCheckoutFlowHost();
    this.showCheckOutComSpinner = true;
    this.checkoutFramesInitCancelled = false;
    this.checkoutFramesInitializing = true;
    const initSeq = ++this.checkoutFramesInitSeq;

    if (!this.keys?.publicKey) {
      this.checkoutFramesInitializing = false;
      this.handleCheckoutFlowError({ message: "Missing Checkout.com credentials" }, true);
      return;
    }

    // Run state updates inside Angular's zone so a CD cycle is always scheduled,
    // regardless of whether the caller is inside or outside the zone.
    // ngZone.run() replaces the former synchronous detectChanges() call, which
    // re-entered Angular's CD loop when invoked from inside checkBoxChanged()
    // (triggered by ionChange during a CD pass) and caused Qk/Ok to call each
    // other infinitely (LOTTOSOCIAL-PWA-1NBM).
    // markForCheck() is added for OnPush ancestors — ngZone.run() alone schedules
    // a CD tick but does not mark OnPush components dirty.
    // DOM-access safety: all iframe container mounting happens inside the
    // requestAnimationFrame below. rAF fires on the next browser paint, which is
    // always after Angular's zone-triggered CD cycle has updated the DOM for
    // isCheckoutComform / isButtonDisabled. No DOM-dependent work runs before that.
    this.ngZone.run(() => {
      this.isCheckoutComform = true;
      this.isButtonDisabled = true;
      this.changeDetRef.markForCheck();
    });

    if (this.checkoutFramesInitFrame !== null) {
      cancelAnimationFrame(this.checkoutFramesInitFrame);
      this.checkoutFramesInitFrame = null;
    }
    this.checkoutFramesInitFrame = requestAnimationFrame(async () => {
      this.checkoutFramesInitFrame = null;
      if (this.isDestroyed || this.checkoutFramesInitCancelled || initSeq !== this.checkoutFramesInitSeq) {
        this.checkoutFramesInitializing = false;
        return;
      }
      try {
        const paymentData = this.checkoutFlowService.buildCheckoutFlowPaymentData(host);
        await this.checkoutFlowService.mountCheckoutFlowUi(host, paymentData, initSeq);
      } catch (error) {
        if (
          this.isDestroyed ||
          initSeq !== this.checkoutFramesInitSeq ||
          (error as Data)?.code === "checkout_flow_mount_cancelled"
        ) {
          return;
        }
        this.handleCheckoutFlowError(error as Data, true);
      } finally {
        if (initSeq === this.checkoutFramesInitSeq) {
          this.checkoutFramesInitializing = false;
        }
      }
    });
  }

  /** Called by CheckoutFlowService when Flow reports ready. */
  public onCheckoutFlowReady(): void {
    // Spinner/error cleanup is handled in CheckoutFlowService.onCheckoutIframeReady.
  }

  public checkoutPaymentDoneFlow(): void {
    // Resolve purchase id before payment_success so AppLovin transaction_id is not empty.
    const continueAfterGtm = () => {
      if (this.postPaymentTicketFlowStarted) {
        if (this.customerPurchaseEncryptedId) {
          this.paymentService.salesJourneyCustomerPurchaseId$.next(this.customerPurchaseEncryptedId);
        }
        return;
      }
      this.postPaymentTicketFlowStarted = true;
      this.paymentService.resetPostPaymentTicketState();
      if (this.customerPurchaseEncryptedId) {
        this.paymentService.salesJourneyCustomerPurchaseId$.next(this.customerPurchaseEncryptedId);
      }
      this.paymentService?.setSyndicatePending();
      this.syncPaymentLogToFireStore();
      this.checkStickyUiForProsub();
      localStorage.setItem("sjFlow", "addCard");
      setTimeout(() => {
        this.callInt2();
      }, 500);
    };

    this.pushCheckoutPaymentSuccessGtm(continueAfterGtm);
  }

  /** New-card: prefer plain customer_purchase_id from Checkout.com doc when available. */
  private pushCheckoutPaymentSuccessGtm(onPushed?: () => void): void {
    const knownId =
      this.customer_purchase_id ||
      this.customerPurchaseEncryptedId ||
      this.paymentService.salesJourneyCustomerPurchaseId$.value ||
      '';

    if (knownId) {
      this.pushPaymentSuccessGtm(undefined, knownId);
      onPushed?.();
      return;
    }

    this.paymentService.getCheckOutComResponse$
      .pipe(
        map((paymentResData: Data) => {
          const purchase = paymentResData?.payment_request?.customer_purchase;
          return (
            purchase?.customer_purchase_id ||
            purchase?.encrypted_customer_purchase_id ||
            ''
          );
        }),
        take(1),
        timeout({ first: 5000, with: () => of('') })
      )
      .subscribe((cpId) => {
        if (cpId) {
          this.pushPaymentSuccessGtm(undefined, cpId);
        } else {
          this.pushPaymentSuccessGtm(undefined, '');
        }
        onPushed?.();
      });
  }

  /** Checkout.com success: always continue the sales journey even without a live Firebase session. */
  private proceedAfterCheckoutSuccess(user: Data | null, paymentResponse: Data): void {
    this.resetPaymentSubscriptions();
    this.checkoutPaymentSuccess = true;
    this.timerOn = false;
    this.payment_done = "success";
    this.isPaymentDone = false;
    this.paymentReceived = false;

    if (!user) {
      const token = localStorage.getItem("fbToken");
      if (token) {
        this.manualLoginPayment(token, paymentResponse);
        return;
      }
    }

    this.checkoutPaymentDoneFlow();
  }

  private buildCheckoutUserFromLocalStorage(): Data | null {
    const msn =
      this.checkOutComData?.msn ||
      this.safeLocalStorage.getItem("msn") ||
      this.authService.userMSN$?.value ||
      "";
    if (!msn) {
      return null;
    }

    const country_code =
      this.checkOutComData?.country_code ||
      this.safeLocalStorage.getItem("country_code") ||
      "";

    return {
      msn,
      email: this.checkOutComData?.email || `${msn}@lottosocial.com`,
      country_code,
    };
  }

  private resolvePostPaymentUserDetails$() {
    return this.authService.userDetails$.pipe(
      take(1),
      timeout(8000),
      catchError(() => of(null)),
      defaultIfEmpty(null)
    );
  }

  private navigateToFreeRegCompleteProfile(post_name: string): void {
    this.persistCheckoutMsnToStorage();
    this.paymentService.freeRegJourneyStep = "free-reg-journey-4c";
    this.paymentService.freeRegJourneySuccessURL = post_name;
    this.timerOn = false;

    const params = new URLSearchParams({
      prosub_id: this.Prosub_id,
      TP1: this.TP1,
      TP2: this.Tp2,
      TP3: this.TP3,
      T_ID: this.T_ID,
    }).toString();

    this.router.navigateByUrl(`${post_name}?${params}`);
  }

  private persistCheckoutMsnToStorage(): void {
    const checkoutUser = this.buildCheckoutUserFromLocalStorage();
    if (!checkoutUser?.msn) {
      return;
    }

    if (!this.safeLocalStorage.getItem("msn")) {
      this.safeLocalStorage.setItem("msn", checkoutUser.msn);
    }

    if (checkoutUser.country_code && !this.safeLocalStorage.getItem("country_code")) {
      this.safeLocalStorage.setItem("country_code", checkoutUser.country_code);
    }

    if (!this.authService.userMSN$?.value) {
      this.authService.userMSN$.next(checkoutUser.msn);
    }
  }

  private checkoutPaymentFailedFlow(): void {
    this.paymentErrorMessage();
  }

  private resetCheckoutcomStates() {
    try {
      this.loadingService.dismiss();
      this.clearCheckoutIframeRecovery();
      this.resetPaymentSubscriptions();
      this.getCheckOutComResponseSubscription?.unsubscribe();
      this.cardTokenizedCalled = false;
      this.isCheckoutCom = false;
      this.showCheckOutComSpinner = false;
      this.timerOn = false;
      this.addingCard = false;
      this.addNewCardInProgress = false;
      this.showAddNewCard = true;
      this.proceed = true;
      this.isPaymentDone = false;
      this.isCheckoutComform = true;
      this.checkStickyUiForProsub();
      this.redirectlink = this.sanitizer.bypassSecurityTrustResourceUrl(environment.checkOutUrl);
    } catch (error) {
      this.authService.errorHandlerLogs("Error in resetting checkoutcom states:", error);
    }
  }

  // This method has been use to get check Box events and addition of prize.
  checkBoxChanged(event: Data, offerData: Addon) {
    const result = this.cardUpsellService.checkBoxChanged(event as { detail?: { checked?: boolean; value?: number } }, offerData, {
      purchaseDetail: this.purchaseDetail,
      preferredCurrency: this.preferredCurrency,
      checkedValues: this.checkedValues,
      checkedValuesDefaultCurrency: this.checkedValuesDefaultCurrency,
    });
    this.purchaseDetail.addons = result.addons;
    this.checkedValues = result.checkedValues;
    this.checkedValuesDefaultCurrency = result.checkedValuesDefaultCurrency;
    this.addonTotalAmount = result.addonTotalAmount;
    this.totalPrize$.next(result.addonTotalAmount);
    this.setPurchaseDetailInLocalStorage(this.purchaseDetail);
    if (this.selectedCard !== '21') {
      this.updateAddonDataForPaymilPayment(this.purchaseDetail.addons);
    } else if (this.isCheckoutComform && this.keys?.publicKey && !this.cardTokenizedCalled) {
      // Flow session amount is fixed at create time — remount so base + upsell is charged.
      // Three-case guard (LOTTOSOCIAL-PWA-1NBM):
      //   1. checkboxInitialized && amountsInitialized → real user interaction, amounts ready:
      //        remount immediately.
      //   2. checkboxInitialized && !amountsInitialized → real user interaction in the
      //        window between zone-stable and 2s amounts-init: defer as pendingCheckoutRemount;
      //        the 2s init block executes it with a full condition re-check once totals are set.
      //   3. !checkboxInitialized → synthetic first-render ionChange from ion-checkbox
      //        [(ngModel)] reconciliation. Silently ignored — NOT deferred.
      //        Timing rationale: both Phase 1 (checkboxInitialized) and Phase 2 (amounts)
      //        are scheduled via ngZone.runOutsideAngular(), so their pending macro-tasks do
      //        NOT keep NgZone unstable. NgZone.onStable fires within milliseconds of the
      //        first render — long before a user can physically interact with a checkbox.
      //        Any ionChange arriving while checkboxInitialized is false is therefore
      //        guaranteed to be the synthetic first-render reconciliation event, not a real
      //        user gesture. The initial Checkout Flow session is created by the normal page
      //        setup flow; no remount is needed for the synthetic event.
      if (this.checkboxInitialized && this.amountsInitialized) {
        // Immediate remount — amounts are ready. Wrap in try/catch so a synchronous
        // throw is logged and does not leave pendingCheckoutRemount in an ambiguous
        // state. On success, clear any stale pending flag from a previous failed attempt.
        try {
          this.initializeCheckoutFlowIFrames();
          this.pendingCheckoutRemount = false; // clear stale flag only on success
        } catch (remountError) {
          this.authService.errorHandlerLogs('[PaymentPage] immediate remount failed', remountError);
          // pendingCheckoutRemount stays as-is — next toggle will retry
        }
      } else if (this.checkboxInitialized) {
        // Real user interaction before amounts are ready — defer.
        this.pendingCheckoutRemount = true;
      }
      // else: synthetic first-render event — ignore completely.
    }
  }

  public setCardAsPrimaryMethod(): void {
    this.paymentCardService?.setCardAsPrimaryMethod();
  }

  private async modifyAddonContent() {
    // Add null/undefined validation to prevent "undefined is not an object" error
    // Check if purchaseDetail exists, offers exists, add_on exists and is an array
    if (!this.purchaseDetail || !this.purchaseDetail.offers || !this.purchaseDetail.offers.add_on) {
      return;
    }

    this.purchaseDetail = await this.cardUpsellService.modifyAddonContent(this.purchaseDetail);
  }

  // Set default upsell data — applies returned structured output
  private setDefaultUpsellData(): void {
    const result = this.cardUpsellService.setDefaultUpsellData({
      isDestroyed: this.isDestroyed,
      safeLocalStorage: this.safeLocalStorage,
      preferredCurrency: this.preferredCurrency,
      purchaseDetail: this.purchaseDetail,
      upsellList: this.upsellList,
      p_id: this.p_id,
    });

    if (result) {
      this.preferredCurrency = result.preferredCurrency;
      this.purchaseDetail = result.purchaseDetail;
      this.totalOfferPrizeValue = result.totalOfferPrizeValue;
      this.setPurchaseDetailInLocalStorage(this.purchaseDetail);
    }
  }

  // This function used to get cookie value to the given name.
  public getCookie(name) {
    try {
      if (document && document !== null && typeof document !== "undefined") {
        var nameEQ = name + "=";
        var cookie = document.cookie?.split(";");
        for (var i = 0; i < cookie.length; i++) {
          var c = cookie[i];
          while (c.charAt(0) == " ") c = c?.substring(1, c.length);
          if (c?.indexOf(nameEQ) == 0) return c?.substring(nameEQ.length, c.length);
        }
      }
      return null;
    } catch (e) {
      return e;
    }
  }

  public async showFourCAlertFromSyndicatePaymentStatus(payment_status: Data): Promise<void> {
    if (!this.isFourCCheckoutRoute()) return;

    const resultCode = String(payment_status?.result?.code ?? '').trim();
    const isSuccess = resultCode ? this.paymentFlowService.isPaymentSuccess(resultCode) : false;
    const fallbackText = String(payment_status?.result?.description ?? payment_status?.message ?? '').trim() || (isSuccess ? 'Transaction succeeded' : 'Something went wrong!');

    if (isSuccess) {
      await this.showFourCAlertByConstantsCode('1145', fallbackText || 'Transaction succeeded', 'success');
    } else {
      await this.showFourCAlertByConstantsCode('1014', fallbackText || 'Something went wrong!', 'error');
    }
  }

  // This method is used to contain payment error message logic in case of payment failure
  public isFourCCheckoutRoute(): boolean {
    try {
      const url = (this.router.url || "").toLowerCase();
      if (url.includes("free-reg-step4c") || url.includes("free-reg-step-4c")) {
        return true;
      }
      if (typeof location !== "undefined") {
        const href = location.href.toLowerCase();
        if (href.includes("free-reg-step4c") || href.includes("free-reg-step-4c")) {
          return true;
        }
      }
      if (this.safeLocalStorage.getItem("4cpage") !== "free-reg-step-4c") {
        return false;
      }
      return url.includes("/payment") || url.includes("free-reg");
    } catch {
      return false;
    }
  }

  private mapToastStyleTypeToFourCSeverity(typeStr: string): ToastSeverity {
    const t = (typeStr || "").toLowerCase();
    if (t === "success") return "success";
    if (t === "info") return "info";
    if (t === "warning") return "warning";
    if (t === "action_required") return "action_required";
    return "error";
  }

  /**
   * Loads copy from Firestore toast_message (per-locale) and renders the 4C static alert.
   */
  private resolveFourCAlertLines(
    translated: Data | null,
    fallback: ToastPayload
  ): { line1: string; line2: string } {
    const msg = translated?.message;
    if (typeof msg === "string" && msg) {
      return { line1: msg, line2: "" };
    }
    if (msg && typeof msg === "object") {
      const line1 = (msg.line_1 && String(msg.line_1).trim())
        ? msg.line_1
        : fallback.message.line_1;
      return {
        line1,
        line2: msg.line_2 ?? fallback.message.line_2 ?? "",
      };
    }
    return {
      line1: fallback.message.line_1,
      line2: fallback.message.line_2 ?? "",
    };
  }

  private async applyFourCPaymentAlertFromFirestoreDoc(
    docId: string,
    fallback: ToastPayload
  ): Promise<void> {
    if (!this.isFourCCheckoutRoute() || this.isDestroyed) return;
    try {
      const translated = (await this.authService.getConstantsMsg(docId)) as Data | null;
      if (this.isDestroyed) return;
      const { line1, line2 } = this.resolveFourCAlertLines(translated, fallback);
      const typeStr = (translated?.style?.type ?? fallback.style.type ?? "").toString();
      this.setFourCPaymentAlert({
        line1,
        line2,
        severity: this.mapToastStyleTypeToFourCSeverity(typeStr),
      });
    } catch {
      if (this.isDestroyed) return;
      const typeStr = (fallback.style.type ?? "").toString();
      this.setFourCPaymentAlert({
        line1: fallback.message.line_1,
        line2: fallback.message.line_2,
        severity: this.mapToastStyleTypeToFourCSeverity(typeStr),
      });
    }
  }

  /** Updates the 4C static alert only while the view is still alive. */
  private setFourCPaymentAlert(alert: {
    line1: string;
    line2?: string;
    severity: ToastSeverity;
  }): void {
    if (this.isDestroyed) return;
    this.fourCPaymentAlert = alert;
    this.changeDetRef.detectChanges();
  }

  public async showFourCAlertByConstantsCode(
    code: string,
    fallbackLine1: string,
    severity: ToastSeverity
  ): Promise<void> {
    if (!this.isFourCCheckoutRoute() || this.isDestroyed) return;
    const fallback: ToastPayload = {
      message: { line_1: fallbackLine1 || "Something went wrong!", line_2: "" },
      style: {
        type: severity,
        icon: severity === "success" ? "tick circle success.png" : "tick circle error.svg",
        duration_ms: 0,
      },
    };
    await this.applyFourCPaymentAlertFromFirestoreDoc(code, fallback);
  }

  public async showFourCAlertFromMappedCheckoutStatus(payment_status: Data): Promise<void> {
    if (!this.isFourCCheckoutRoute() || this.isDestroyed) return;
    const docId = this.paymentService.resolveFourCPaymentFeedbackDocId(payment_status);
    const fallback = this.paymentService.mapFourCPaymentFeedbackFallback(docId);
    const rawLine =
      payment_status?.payment_response_description ??
      payment_status?.result?.description ??
      payment_status?.message;
    if (rawLine && !fallback.message.line_1) {
      fallback.message.line_1 = String(rawLine);
    }
    await this.applyFourCPaymentAlertFromFirestoreDoc(docId, fallback);
  }

  private paymentErrorMessage(): void {
    // Use the customerPurchaseEncryptedId if available from the checkout flow
    if (this.customerPurchaseEncryptedId) {
      if (this.isFourCCheckoutRoute()) {
        const genericFailureLine = "There is an issue in processing payment";
        this.paymentService
          .getCustomerPurchaseDetailsFromEncryptedCpId(this.customerPurchaseEncryptedId)
          .pipe(takeUntil(this.destroy$), take(1))
          .subscribe({
            next: (purchaseDoc) => {
              if (this.isDestroyed) return;
              if (purchaseDoc) {
                void this.showFourCAlertFromMappedCheckoutStatus(purchaseDoc);
              } else {
                void this.showFourCAlertByConstantsCode("1026", genericFailureLine, "error");
              }
            },
            error: (err) => {
              if (this.isDestroyed) return;
              this.authService.errorHandlerLogs("paymentErrorMessage: customer purchase lookup failed", err);
              void this.showFourCAlertByConstantsCode("1026", genericFailureLine, "error");
            },
          });
      } else {
        this.paymentService.paymentErrorMessage(this.customerPurchaseEncryptedId);
      }
      this.resetCheckoutcomStates();
      if (this.storedCards && this.storedCards?.length === 0) {
        this.addNewCard();
      }
    } else {
      // Fallback to showing a generic error message if no customer purchase ID is available
      const defaultMsg = {
        message: {
          line_1: "There is an issue in processing payment",
          line_2: "",
        },
        style: {
          icon: "tick circle error.svg",
          type: "Error",
        },
      };
      if (this.isFourCCheckoutRoute()) {
        this.setFourCPaymentAlert({
          line1: defaultMsg.message.line_1,
          severity: "error",
        });
      } else {
        this.authService.showToastMessage({}, defaultMsg);
      }
      this.resetCheckoutcomStates();
      if (this.storedCards && this.storedCards?.length === 0) {
        this.addNewCard();
      }
    }
  }
  storeSliderOptions2: SwiperOptions = {
    autoplay: false,
    speed: 500,
    spaceBetween: 10,
    slidesPerView: 2.1,
    centerInsufficientSlides: true,
    edgeSwipeThreshold: 4,
    grabCursor: true,
  };
  slides: Swiper;
  interval;
  // Get upsell list
  getUpsellData(upsell_ID: string) {
    try {
      this.upsellListSubscription?.unsubscribe();
      this.upsellListSubscription = this.paymentService?.getUpsellList(upsell_ID).subscribe({
        next: (data) => {
          if (!this.isDestroyed) {
            this.upsellList = data?.upsell_list || [];
          }
        },
        error: (error) => {
          this.authService.errorHandlerLogs("Error fetching upsell list:", error);
        },
      });
    } catch (error) {
      this.authService.errorHandlerLogs("Error in getUpsellData:", error);
      return error;
    }
  }

  // To set purchase detail in local storage which can be used when user comes back to this page after 3DS approval
  public setPurchaseDetailInLocalStorage(purchaseDetail: Data): void {
    localStorage.setItem("purchaseDetailData", JSON.stringify(purchaseDetail));
  }

  // To set the sticky style to payment UI for specific checkout prosubs
  private checkStickyUiForProsub(): void {
    try {
      this.fixFooter = this.purchaseDetail?.offers?.sticky_iframe?.toLowerCase() === "yes" ? true : false;
    } catch (error) {
      this.fixFooter = false;
    }
  }

  private cleanupCheckboxListeners(): void {
    if (!this.checkboxListeners.length) {
      return;
    }

    this.checkboxListeners.splice(0).forEach((unlisten) => {
      try {
        unlisten();
      } catch (error) {
        this.authService.errorHandlerLogs("Error cleaning checkbox listener:", error);
      }
    });
  }

  // Get checkbox value configuration from slides — applies returned configuration
  getCheckBoxValue() {
    if (this.isDestroyed) {
      return;
    }

    this.cleanupCheckboxListeners();

    const nativeEl = this.el?.nativeElement;
    if (!nativeEl) {
      return;
    }

    const config = this.cardUpsellService.getCheckBoxValue({
      el: this.el,
      purchaseDetail: this.purchaseDetail,
      preferredCurrency: this.preferredCurrency,
    });

    // Apply checkbox configuration and event listeners
    const slides = nativeEl.querySelectorAll(".bonus-slide") as NodeListOf<HTMLElement>;
    const swiperSlide = nativeEl.querySelectorAll(".swiper-slide") as NodeListOf<HTMLElement>;

    if (!config?.checkboxConfigs?.length) {
      return;
    }

    config.checkboxConfigs.forEach(({ index, priceValue }) => {
      const slide = slides[index];
      const slideCard = swiperSlide[index];
      const checkbox = slide?.querySelector("ion-checkbox");

      if (!slide || !slideCard || !checkbox) {
        return;
      }

      // Set the value property
      this.renderer.setProperty(checkbox, "value", priceValue);

      // Add event listener for ionChange event
      this.checkboxListeners.push(
        this.renderer.listen(checkbox, "ionChange", (event) => {
          const offerDeals = this.purchaseDetail?.offers?.add_on?.[index] as Addon | undefined;
          if (!offerDeals) {
            return;
          }

          // Set or remove the "added-card" class based on event?.detail?.checked
          if (event?.detail?.checked) {
            this.renderer.addClass(slideCard, "added-card");
          } else {
            this.renderer.removeClass(slideCard, "added-card");
          }
          // Handle checkbox change
          this.checkBoxChanged(event, offerDeals);
        })
      );
    });
  }

  handle_pay_response(
    process_card_payment_resp: any,
    encrypted_customer_purchase_id: string,
    one_click_pay: boolean
  ) {
    this.stopSpinner();
    this.loadingService.dismiss();

    if (
      process_card_payment_resp?.response &&
      process_card_payment_resp?.response?.status === CommonVariable.success
    ) {
      if (encrypted_customer_purchase_id) {
        return this.pollPaymentStatus(
          encrypted_customer_purchase_id,
          one_click_pay
        );
      }
      this.completePaymentSuccessFromApiResponse(
        process_card_payment_resp,
        encrypted_customer_purchase_id
      );
      return;
    }

    if (process_card_payment_resp?.status == 0) {
      const alt_prosub_id = process_card_payment_resp?.Alternate_prosub_id;
      const queryParams = this.actRoute.snapshot.queryParams || {};
      if (alt_prosub_id != "") {
        const updatedQueryParams = {
          ...queryParams,
          prosub_id: alt_prosub_id,
          TP1: this.TP1,
          TP2: this.Tp2,
          TP3: this.TP3,
          T_ID: this.T_ID,
        };

        this.router.navigate(
          ['/free-reg-step4c'],
          { queryParams: updatedQueryParams }
        );
        return;
      } else {
        this.router.navigateByUrl("product-not-available");
        return;
      }
    } else if (process_card_payment_resp?.status == 2) {
      this.paymentService.emitSyndicatePurchaseComplete();
      this.pushPaymentSuccessGtm(
        process_card_payment_resp,
        encrypted_customer_purchase_id
      );
      setTimeout(() => {
        this.router.navigate(["/free-reg-complete-profile"], {
          queryParams: {
            prosub_id: this.Prosub_id,
            TP1: this.TP1,
            TP2: this.Tp2,
            TP3: this.TP3,
            T_ID: this.T_ID,
            sid: process_card_payment_resp?.encrypt_syndicate_id,
          },
        });
      }, 500);
      return;
    }

    

    if (process_card_payment_resp?.status === "rejected") {
      const errCode = String(process_card_payment_resp?.error_code ?? "1086");
      this.showPayFailureConstantsOrToast(errCode, "Something went wrong!");
      if (one_click_pay) {
        this.fallbackFromFailedSwipeToAddCard();
      } else {
        this.changeSlideBtnStatus();
      }
      return;
    }

    if (
      process_card_payment_resp?.response &&
      process_card_payment_resp?.response?.status !== CommonVariable.success
    ) {
      this.showPayFailureConstantsOrToast(
        "1049",
        "Transactions failed, please add new card"
      );
      if (one_click_pay) {
        this.fallbackFromFailedSwipeToAddCard();
      } else {
        this.changeSlideBtnStatus();
        setTimeout(() => {
          this.addNewCard();
        }, 3000);
      }
      return;
    }
    this.showPayFailureConstantsOrToast("1050", "Failed in processing payment");
    if (one_click_pay) {
      this.fallbackFromFailedSwipeToAddCard();
    } else {
      this.changeSlideBtnStatus();
    }
    return;
  }


  handleCheckoutIdFailure() {
    this.loadingService.dismiss();
    this.addingCard = false;
    this.addNewCardInProgress = false;
    this.showAddNewCard = true;
    this.proceed = true;
    this.isPaymentDone = false;
    this.authService.errorHandlerLogs("getCheckoutId returned null response - user authentication may be invalid");
    this.showPayFailureConstantsOrToast(
      "1088",
      "Unable to process payment. Please try logging in again."
    );
    return;
  }

  async handleCheckoutIdSuccess(res: Data) {
    if (!res?.id) {
      this.handleCheckoutIdFailure();
      return;
    }

    this.updateLogToLocal({ co_response: res, co_endDate: new Date() });

    if (res.id) {
      this.loadingService.dismiss();
      this.currentNdc = res?.id;
      this.paymentService.currentNdcId = this.currentNdc;
      try {
        await this.paymilPaymentService.unloadPaymentWidget(window);
      } catch (error) {
        return error;
      }
      this.pathString = this.utilityService.loadScriptForPayment([res?.paymentWidgetUrl]);
      this.paymilPaymentService.dismissLoaderAfterTimeout();
      this.utilityService.checkIframeInputFocus();
      this.addingCard = true;
      this.updateAddonDataForPaymilPayment(this.purchaseDetail.addons);
      this.basePaymentService.start(CommonVariable.paymentTimer, this.timerspan, () => {
        this.timeOut = true;
        this.addingCard = false;
        this.addNewCardInProgress = false;
        this.showAddNewCard = true;
        this.count = 0;
        this.isPaymentDone = false;
      })
    } else {
      if (res && res.message === "Timeout has occurred") {
        this.addingCard = false;
        this.addNewCardInProgress = false;
        this.showAddNewCard = true;
        this.proceed = true;
        this.isPaymentDone = false;
        const translatedMsg = {
          message: {
            line_1: res.message + ", Please try again!",
            line_2: "",
          },
          style: {
            duration: 2000,
            icon: "tick circle error.svg",
            type: CommonVariable.error,
          },
        };
        const defaultMsg = {
          message: {
            line_1: "Something went wrong!",
            line_2: "",
          },
          style: {
            icon: "tick circle error.svg",
            type: CommonVariable.error,
          },
        };
        if (this.isFourCCheckoutRoute()) {
          const t = translatedMsg as Data;
          this.setFourCPaymentAlert({
            line1: t?.message?.line_1 ?? defaultMsg.message.line_1,
            line2: t?.message?.line_2,
            severity: "error",
          });
        } else {
          this.authService.showToastMessage(translatedMsg, defaultMsg);
        }
        return;
      }
      this.loadingService.dismiss();
      this.addingCard = false;
      this.addNewCardInProgress = false;
      this.showAddNewCard = true;
      this.proceed = true;
      this.isPaymentDone = false;
      this.showPayFailureConstantsOrToast("1086", "Something went wrong. Please try again.");
    }
  }

  handleCheckoutIdError(err) {
    this.authService.errorHandlerLogs("getCheckoutId error:", err);
    this.loadingService.dismiss();
    this.getCheckOutEroor++;
    this.addNewCardInProgress = false;
    this.showAddNewCard = true;
    this.addingCard = false;
    this.proceed = true;
    this.isPaymentDone = false;

    if (this.getCheckOutEroor > this.maxCheckOutTries) {
      this.showPayFailureConstantsOrToast(
        "1050",
        "Unable to initialize payment. Please try again later."
      );
    } else {
      this.showPayFailureConstantsOrToast("1086", "Payment initialization failed. Please try again.");
    }
    return err;
  }

  processAfterPayment(purchaseDoc: Data) {
    const processed_status = purchaseDoc.processed_status;
    if (processed_status === 2) {
      const payment_status = purchaseDoc.payment_status;
      const statusData =
        typeof payment_status === "string"
          ? JSON.parse(payment_status)
          : typeof payment_status === "object"
            ? payment_status
            : {};
      this.onPaymentStatusReceived(statusData, true);
      this.resetPaymentSubscriptions();
    } else if (processed_status === -1) {
      this.showPayFailureConstantsOrToast("1050", "Payment failed, please try again!");
      this.resetPaymentState()
    }
  }

 handleFormSelectedCard() {
    this.formSelectedCardSubscription?.unsubscribe();

    const uid$ = this.commonServiceLocal.getUid("PaymentPage.handleFormSelectedCard").pipe(
      take(1),
      timeout(15000),
      catchError(() => of(null)),
      defaultIfEmpty(null)
    );

    const cachedUser = this.buildCheckoutUserFromLocalStorage();
    if (cachedUser?.msn) {
      // Anonymous / partial-reg users may not have userDetails$ MSN in time.
      // Start checkout immediately using MSN from partial registration.
      this.formSelectedCardSubscription = uid$.pipe(take(1)).subscribe((uid) => {
        this.beginCheckoutComFlow(cachedUser, uid);
      });
      return;
    }

    const user$ = this.authService.userDetails$.pipe(
      filter((user: Data) => !!user?.msn),
      take(1),
      timeout(8000),
      catchError(() => of(null)),
      defaultIfEmpty(null),
      map((user) => user ?? this.buildCheckoutUserFromLocalStorage()),
      filter((user): user is Data => !!user?.msn)
    );

    this.formSelectedCardSubscription = combineLatest([user$, uid$])
      .pipe(take(1))
      .subscribe(([user, uid]) => {
        if (!user) {
          return;
        }
        this.beginCheckoutComFlow(user, uid);
      });
  }

  private beginCheckoutComFlow(user: Data, uid: string | null): void {
    this.userId = uid as string;
    this.userData = user;
    const data = { ...this.purchaseDetail, ...user };
    this.addNewCardInProgress = true;
    this.addingCard = true;
    this.timerOn = true;
    this.isCheckoutCom = true;
    this.loadingService.hasRenderedSignal.set(true);
    this.startCheckoutComSessionTimer(data);
    this.loadCheckoutComFlow(data);
  }

  // Checkout.com Frames are rendered from a long-lived publishable key (pk_...) and the
  // hosted card form does not expire. Tearing the iframe down when the countdown ends
  // (a behaviour inherited from the old Paymill hosted-widget flow) left the user with a
  // blank/missing card form. Instead, when the timer elapses we refresh the form in place
  // and re-arm the countdown so the payment field never silently disappears.
  private startCheckoutComSessionTimer(data: Data): void {
    this.basePaymentService.start(
      CommonVariable.paymentTimer,
      this.timerspan,
      () => this.refreshCheckoutComSession(data)
    );
  }

  private refreshCheckoutComSession(data: Data): void {
    // Only refresh while the card form is actually on screen. Skip when a payment is
    // already in progress (mid-tokenization / 3DS challenge), or when the form has been
    // closed/failed and the user is back on the add-card screen, so we never silently
    // re-open the payment form on an abandoned session.
    if (
      this.isDestroyed ||
      this.cardTokenizedCalled ||
      !this.isCheckoutComform ||
      !this.addingCard
    ) {
      return;
    }

    this.timeOut = false;
    this.addingCard = true;
    this.addNewCardInProgress = true;
    this.isCheckoutComform = true;
    this.checkoutFlowService.resetCheckoutCardFrame();
    this.startCheckoutComSessionTimer(data);
    this.loadCheckoutComFlow(data);
  }

  public async updateAddonDataForPaymilPayment(addOnData: Data[]) {
    const userId = this.userId;
    const ndcId = this.paymentService.currentNdcId;
    if (!userId || !ndcId) {
      return;
    }
    if (typeof userId === "string" && typeof ndcId === "string") {
      try {
        this.basePaymentService.updateAddonDataForPaymilPayment(addOnData, this.currentNdc);
      } catch (error) {
        return error;
      }
    }
  }

  formatCurrencyAmountDisplay(amount: number | string): string {
    const parsedAmount = Number(amount);
    const safeAmount = Number.isFinite(parsedAmount) && parsedAmount > 0 ? parsedAmount : 0;
    const roundedAmount = Math.round((safeAmount + Number.EPSILON) * 100) / 100;

    if (this.preferredCurrency === "GBP" && roundedAmount >= 0.01 && roundedAmount < 1) {
      return `${Math.round(roundedAmount * 100)}p`;
    }

    return `${this.currencySymbol}${formatDisplayCurrencyAmount(roundedAmount)}`;
  }

  private readonly TRUSTPILOT_SUPPORTED_LANGS = ["en", "it", "es", "fr", "pt"];
  private readonly TRUSTPILOT_FALLBACK_LANG = "en";

  private extractTrustpilotData(source: any): any {
    if (!source) {
      return null;
    }

    return (
      source?.trustpilot_data ||
      source?.offers?.trustpilot_data ||
      source?.prosubDetail?.trustpilot_data ||
      source?.result?.prosubDetail?.trustpilot_data ||
      source?.offers?.result?.prosubDetail?.trustpilot_data ||
      source?.data?.prosubDetail?.trustpilot_data ||
      null
    );
  }

  private trackCustomerPurchaseForCheckout(cpId: string): void {
    this.checkoutFlowService.trackCustomerPurchaseForCheckout(this.asCheckoutFlowHost(), cpId);
  }


  private getTrustpilotData(): any {
    const cachedPurchaseDetail = this.safeLocalStorage.getItem("purchaseDetailData");
    let parsedPurchaseDetail: any = null;

    if (cachedPurchaseDetail) {
      try {
        parsedPurchaseDetail = JSON.parse(cachedPurchaseDetail);
      } catch {
        parsedPurchaseDetail = null;
      }
    }

    const candidates = [
      this.purchaseDetail,
      this.altprosubDetails,
      this.fourCPaymentResponse,
      parsedPurchaseDetail,
    ];

    for (const candidate of candidates) {
      const trustpilotData = this.extractTrustpilotData(candidate);
      if (trustpilotData) {
        return trustpilotData;
      }
    }

    return null;
  }

  private isTrustpilotEnabled(trustpilotData: any): boolean {
    const rawValue = trustpilotData?.enable_user_reviews;

    if (rawValue === undefined || rawValue === null) {
      return this.normalizeTrustpilotReviews(trustpilotData?.user_reviews).length > 0;
    }

    if (typeof rawValue === "string") {
      const normalized = rawValue.toLowerCase().trim();
      return normalized === "true" || normalized === "1" || normalized === "yes";
    }
    return rawValue === true || rawValue === 1;
  }

  private normalizeTrustpilotReviews(rawReviews: any): any[] {
    if (!rawReviews) {
      return [];
    }

    let parsedReviews = rawReviews;
    if (typeof parsedReviews === "string") {
      try {
        parsedReviews = JSON.parse(parsedReviews);
      } catch {
        return [];
      }
    }

    if (Array.isArray(parsedReviews)) {
      return parsedReviews.filter(Boolean);
    }

    if (typeof parsedReviews === "object") {
      if (parsedReviews?.review_text || parsedReviews?.review_user) {
        return [parsedReviews];
      }
      return Object.values(parsedReviews).filter(Boolean);
    }

    return [];
  }

  hasTrustpilotReviews(): boolean {
    return this.getTrustpilotReviews().length > 0;
  }

  getTrustpilotReviews(): any[] {
    const trustpilotData = this.getTrustpilotData();
    if (!this.isTrustpilotEnabled(trustpilotData)) return [];
    return this.normalizeTrustpilotReviews(trustpilotData?.user_reviews);
  }

  getReviewText(review: any): string {
    const lang = this.TRUSTPILOT_SUPPORTED_LANGS.includes(this.languageCode)
      ? this.languageCode
      : this.TRUSTPILOT_FALLBACK_LANG;
    return review?.review_text?.[lang] || review?.review_text?.[this.TRUSTPILOT_FALLBACK_LANG] || "";
  }

  getReviewUser(review: any): string {
    const lang = this.TRUSTPILOT_SUPPORTED_LANGS.includes(this.languageCode)
      ? this.languageCode
      : this.TRUSTPILOT_FALLBACK_LANG;
    return review?.review_user?.[lang] || review?.review_user?.[this.TRUSTPILOT_FALLBACK_LANG] || "";
  }
  // ============================================== New Check out Iframe Redirect Handling ==============================================
  //=====================================================================================================================================
  
  private async handleCheckoutFlowRedirectSuccess(
    redirectReturn: CheckoutFlowRedirectReturn
  ): Promise<void> {
  
  
    const checkoutFlowUserId = redirectReturn.userId;
    if (!checkoutFlowUserId) {
    this.authService.errorHandlerLogs('checkoutFlowUserId missing');
      return;
    }
  
    this.applyCheckoutFlowRedirectContext(redirectReturn);
    this.clearCheckoutFlowReturnQueryParams();
    this.waitForCheckoutFlowPaymentConfirmation('redirect');
  }

  /** Post-3DS failure: show toast and remount Flow for retry. */
  private handleCheckoutFlowRedirectFailure(data: Data): void {
    this.isCheckoutResponseReceived = false;
    this.cardTokenizedCalled = false;
    this.showCheckOutComSpinner = false;
    this.loadingService.dismiss();
    this.basePaymentService.showToast("1050", "Payment failed, please try again!", "Error");
    // Allow a fresh Flow mount after a handled redirect failure.
    this.checkoutFlowRedirectHandled = false;
    this.loadCheckoutComFlow(data);
  }

  /** [CheckoutFlow FE#1] Returns true when a redirect return was handled (success or fail). */
  private handleCheckoutFlowRedirect(): boolean {
    if (this.checkoutFlowRedirectHandled) {
      return true;
    }

    const queryParams = this.actRoute.snapshot.queryParams || {};
    const redirectReturn = this.checkoutFlowService.parseRedirectReturn(queryParams);
    if (!redirectReturn.isRedirectReturn) {
      return false;
    }

    this.checkoutFlowRedirectHandled = true;
    if (redirectReturn.status === "success") {
      this.handleCheckoutFlowRedirectSuccess(redirectReturn);
      return true;
    }

    if (redirectReturn.status === "fail") {
      this.clearCheckoutFlowReturnQueryParams();
      const data = { ...this.purchaseDetail, ...this.userData };
      this.handleCheckoutFlowRedirectFailure(data);
      return true;
    }

    return true;
  }

  /** Restore logId / userId from redirect query params so Firestore listener targets the correct doc. */
  private applyCheckoutFlowRedirectContext(redirectReturn: CheckoutFlowRedirectReturn): void {
    if (redirectReturn.logId) {
      this.pathString = redirectReturn.logId;
      localStorage.setItem("myuuid", String(redirectReturn.logId));
      this.paymentService.setcheckOutComDocId({ docId: String(redirectReturn.logId) });
    }
    if (redirectReturn.userId) {
      this.userId = redirectReturn.userId;
      this.paymentService.checkoutFlowUserId$.next(redirectReturn.userId);
      this.authService.setCheckoutFlowUserId(redirectReturn.userId);
    }
    this.isCheckoutCom = true;
    this.addingCard = true;
    this.addNewCardInProgress = true;
    this.showCheckOutComSpinner = true;
    this.cardTokenizedCalled = true;
  }

  private clearCheckoutFlowReturnQueryParams(): void {
    const cleaned = this.checkoutFlowService.stripRedirectReturnParams({
      ...this.actRoute.snapshot.queryParams,
    });
    void this.router.navigate([], {
      relativeTo: this.actRoute,
      queryParams: cleaned,
      replaceUrl: true,
    });
  }

  /**
   * [CheckoutFlow FE#2][FE#3] Subscribe to checkoutcom/{logId} and fulfil only after
   * backend writes payment_response — never on URL status or SDK onPaymentCompleted alone.
   */
  private waitForCheckoutFlowPaymentConfirmation(
    source: "redirect" | "onPaymentCompleted"
  ): void {
    this.showCheckOutComSpinner = true;
    this.loadingService.present();
    this.safeLocalStorage.removeItem("anonymousId");
    this.getCheckOutComResponseSubscription?.unsubscribe();
    this.getCheckOutComResponseSubscription = this.paymentService.getCheckOutComResponse$
      .pipe(
        takeUntil(this.destroy$),
        filter((paymentResData: Data) => {
          const status = paymentResData?.payment_response?.payment_status;
          return status === "success" || status === "fail";
        }),
        take(1),
        timeout(120000),
        catchError((err) => {
          return of(null);
        })
      )
      .subscribe((paymentResData: Data | null) => {
        this.showCheckOutComSpinner = false;
        this.loadingService.dismiss();

        if (!paymentResData?.payment_response) {
          this.handleCheckoutFlowError(
            { message: "Payment confirmation timed out. Please try again." },
            true
          );
          return;
        }

        const paymentResponse = paymentResData.payment_response;
        this.customerPurchaseEncryptedId =
          paymentResData?.payment_request?.customer_purchase?.encrypted_customer_purchase_id;
        const plainCustomerPurchaseId =
          paymentResData?.payment_request?.customer_purchase?.customer_purchase_id;

        if (paymentResponse.payment_status === "success") {
          this.isCheckoutResponseReceived = true;
          this.cardTokenizedCalled = false;
          this.checkoutPaymentSuccess = true;
          this.timerOn = false;
          this.payment_done = "success";
          this.paymentHold = false;
          this.paymentService.emitSyndicatePurchaseComplete();
          // Prefer plain customer_purchase_id for AppLovin transaction_id.
          this.pushPaymentSuccessGtm(
            paymentResData,
            plainCustomerPurchaseId || this.customerPurchaseEncryptedId
          );
          this.checkoutPaymentDoneFlow();
          this.setSalesJournyPaymentDetails(); // Set sales journey payment details when payment is successful
          return;
        }
        const data = { ...this.purchaseDetail, ...this.userData };
        this.handleCheckoutFlowRedirectFailure(data);
      });
  }

  // ============================================== Set Sales Journey Payment Details ==============================================
  //=====================================================================================================================================
  private setSalesJournyPaymentDetails() {
    this.paymentService.getCheckOutComResponse$
      .pipe(
        takeUntil(this.destroy$),
        filter((paymentResData: Data) => {
          const encryptCustomerPurchaseId =
            paymentResData?.payment_request?.customer_purchase?.encrypted_customer_purchase_id;
          if (!encryptCustomerPurchaseId) {
            this.authService.errorHandlerLogs("Encrypt customer purchase id is required");
            return false;
          }
          const status = paymentResData?.payment_response?.payment_status;
          return status === "success" || status === "fail";
        }),
        take(1),
        switchMap((paymentResData: Data) =>
          this.paymentService.watchCustomerPurchaseDoc(
            paymentResData.payment_request.customer_purchase.encrypted_customer_purchase_id
          )
        ),
        catchError((error) => {
          this.authService.errorHandlerLogs(
            "Error setting sales journey payment details",
            error
          );
          return of(null);
        })
      )
      .subscribe((encryptSyndicateId: string | null) => {
        if (encryptSyndicateId) {
          this.paymentService.salesJournyPaymentDetails$.next(encryptSyndicateId);
        }
      });
  }
  
  private isPermissionDeniedCheckoutError(error: Data): boolean {
    const code = String(error?.code ?? "").toLowerCase();
    if (code.includes("permission-denied")) {
      return true;
    }
    return error?.message === "Sandbox access denied.";
  }

  private handleCheckoutFlowError(error: Data, resetUi = false): void {
    this.authService.errorHandlerLogs("[CheckoutFlow]", error);
    this.showCheckOutComSpinner = false;
    this.errorMessage = error?.message || "Failed to load payment form";
    if (this.isPermissionDeniedCheckoutError(error)) {
      this.authService.showToastMessage({}, {
        message: { line_1: "Sandbox access denied.", line_2: "" },
        style: {
          icon: "tick circle error.svg",
          type: "Error",
        },
      });
    }
    if (resetUi) {
      this.addingCard = false;
      this.addNewCardInProgress = false;
      this.showAddNewCard = true;
    }
    this.loadingService.dismiss();
  }
  private startJourney() {
    // Preserve journey_id created at registration entry; only create if missing.
    // Never overwrite on payment re-init (refresh / retry).
    this.salesJourneyIdentityService.ensureJourneyId();
  }

}
